<template>

    <!-- Modal de expiração que cobre toda a tela -->
    <div v-if="isSharedView && isTokenExpired" class="expired-modal-overlay">
      <div class="expired-modal">
        <div class="expired-modal-content">
          <div class="expired-icon">⚠️</div>
          <h2>Link Expirado</h2>
          <p>Este link de compartilhamento expirou em {{ formatExpirationDate(shareData?.expires_at) }}</p>
          <p>Entre em contato com o profissional de saúde para solicitar um novo link.</p>
          <button @click="closeExpiredModal" class="expired-modal-btn">Fechar</button>
        </div>
      </div>
    </div>

    <div v-if="isSharedView && !isTokenExpired" class="share-info-banner">
      <div class="share-info-content">
        <div class="share-info-text">
          <span class="share-label">🔗 Visualização Compartilhada:</span>
          <span v-if="shareData" class="share-details">
            Compartilhado por: {{ shareData.shared_by || 'N/A' }} | 
            Expira em: {{ formatExpirationDate(shareData.expires_at) }}
          </span>
        </div>
      </div>
    </div>
    

    <div class="toolbar">
      <div class="toolbar-group">
        <button @click="toggleSeriesPanel" class="toolbar-btn" title="Mostrar/Ocultar Séries">
          <PanelLeft :size="20" />
          <span class="hidden md:inline">Séries</span>
        </button>
      </div>

      <div class="toolbar-group">
        <button @click="setViewMode('single')" :class="['toolbar-btn', { active: currentViewMode === 'single' }]" title="Visualização Única">
          <Square :size="20" />
          <span class="hidden lg:inline">Única</span>
        </button>
        <button @click="setViewMode('mpr')" :class="['toolbar-btn', { active: currentViewMode === 'mpr' }]" title="MPR (Indisponível)">
          <LayoutGrid :size="20" />
          <span class="hidden lg:inline">MPR</span>
        </button>
      </div>
      
      <div class="toolbar-group">
        <button @click="activateTool('StackScroll')" :class="['toolbar-btn', { active: activeTool === 'StackScroll' }]" title="Rolagem (Scroll)"><Layers :size="18" /></button>
        <button @click="activateTool('Pan')" :class="['toolbar-btn', { active: activeTool === 'Pan' }]" title="Mover (Pan)"><Hand :size="18" /></button>
        <button @click="activateTool('Zoom')" :class="['toolbar-btn', { active: activeTool === 'Zoom' }]" title="Zoom"><ZoomIn :size="18" /></button>
        <button @click="activateTool('Wwwc')" :class="['toolbar-btn', { active: activeTool === 'Wwwc' }]" title="Janelamento (Contraste)"><SunMoon :size="18" /></button>
        <button @click="activateTool('Rotate')" :class="['toolbar-btn', { active: activeTool === 'Rotate' }]" title="Rotação"><RotateCw :size="18" /></button>
        <button @click="activateTool('Magnify')" :class="['toolbar-btn', { active: activeTool === 'Magnify' }]" title="Magnificação">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.35-4.35"/>
            <rect x="7" y="7" width="3" height="3" fill="currentColor"/>
          </svg>
        </button>
      </div>

      <div class="toolbar-group">
        <button @click="activateTool('Length')" :class="['toolbar-btn', { active: activeTool === 'Length' }]" title="Medir Distância"><Ruler :size="18" /></button>
        <button @click="activateTool('Angle')" :class="['toolbar-btn', { active: activeTool === 'Angle' }]" title="Medir Ângulo"><Spline :size="18" /></button>
        <button @click="activateTool('EllipticalRoi')" :class="['toolbar-btn', { active: activeTool === 'EllipticalRoi' }]" title="ROI Elíptica"><Circle :size="18" /></button>
        <button @click="activateTool('RectangleRoi')" :class="['toolbar-btn', { active: activeTool === 'RectangleRoi' }]" title="ROI Retangular"><RectangleHorizontal :size="18" /></button>
        <button @click="activateTool('FreehandRoi')" :class="['toolbar-btn', { active: activeTool === 'FreehandRoi' }]" title="ROI Livre">
          <PenTool :size="18" />
        </button>
        <button @click="activateTool('ArrowAnnotate')" :class="['toolbar-btn', { active: activeTool === 'ArrowAnnotate' }]" title="Anotação (Seta)"><MousePointer2 :size="18" /></button>
        <button @click="activateTool('Eraser')" :class="['toolbar-btn', { active: activeTool === 'Eraser' }]" title="Apagar"><Eraser :size="18" /></button>
      </div>

              <!-- [NOVO] Menu suspenso para controle do cine -->
        <div class="toolbar-group cine-dropdown-container">
          <button @click="toggleCineMenu" :class="['toolbar-btn', { active: isCineActive }]" title="Cine (Reprodução Automática)">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="5,3 19,12 5,21 5,3"/>
            </svg>
            <span class="hidden lg:inline">Cine</span>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="dropdown-arrow">
              <polyline points="6,9 12,15 18,9"></polyline>
            </svg>
          </button>
          

        </div>

      <div class="toolbar-group">
         <button @click="togglePresetsPanel" class="toolbar-btn" title="Presets de Janelamento">
           <Palette :size="20" />
           <span class="hidden lg:inline">Presets</span>
         </button>
         <button @click="invertColors" class="toolbar-btn" title="Inverter Cores"><Contrast :size="20" /></button>
         <button @click="flipHorizontal" class="toolbar-btn" title="Espelhar Horizontal"><FlipHorizontal :size="20" /></button>
         <button @click="flipVertical" class="toolbar-btn" title="Espelhar Vertical"><FlipVertical :size="20" /></button>
      </div>

      <div class="toolbar-group">
         <button @click="resetViewport" class="toolbar-btn" title="Resetar Visualização"><Undo2 :size="20" /></button>
         <button @click="toggleFullscreen" class="toolbar-btn" title="Tela Cheia"><Expand :size="20" /></button>
      </div>

      <!-- [NOVO] Botão para abrir laudo em nova janela popup -->
      <div v-if="pacienteAtual && shouldShowPopupButton" class="toolbar-group">
        <button @click="abrirLaudoEmPopup" class="toolbar-btn" title="Abrir Laudo em Nova Janela">
          <ExternalLink :size="20" />
          <span class="hidden lg:inline">Laudo</span>
        </button>
      </div>
    </div>

    <!-- [NOVO] Menu suspenso do cine com posicionamento fixo -->
    <div v-if="showCineMenu" class="cine-dropdown-menu-fixed" :style="cineMenuPosition">
      <div class="cine-menu-header">
        <h4>Controles do Cine</h4>
        <button @click="toggleCineMenu" class="close-menu-btn">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <!-- Controles de reprodução -->
      <div class="cine-controls-section">
        <div class="cine-control-row">
          <button @click="activateCineTool" :class="['cine-btn', { active: isCineActive }]" :disabled="imageIds.length <= 1">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="5,3 19,12 5,21 5,3"/>
            </svg>
            Iniciar
          </button>
          <button @click="stopCine" class="cine-btn" :disabled="!isCineActive">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="6" y="4" width="4" height="16"/>
              <rect x="14" y="4" width="4" height="16"/>
            </svg>
            Parar
          </button>
        </div>
      </div>
      
      <!-- Controle de direção -->
      <div class="cine-controls-section">
        <label class="cine-section-label">Direção:</label>
        <div class="cine-direction-controls">
          <button @click="setCineDirection('forward')" :class="['direction-btn', { active: cineDirection === 'forward' }]">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="5,3 19,12 5,21 5,3"/>
            </svg>
            Frente
          </button>
          <button @click="setCineDirection('reverse')" :class="['direction-btn', { active: cineDirection === 'reverse' }]">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="19,3 5,12 19,21 19,3"/>
            </svg>
            Reverso
          </button>
        </div>
      </div>
      
      <!-- Controle de velocidade -->
      <div class="cine-controls-section">
        <label class="cine-section-label">Velocidade: {{ cineSpeed }} FPS</label>
        <div class="speed-control-container">
          <input 
            type="range" 
            v-model="cineSpeed" 
            min="0.5" 
            max="10" 
            step="0.5" 
            class="cine-speed-slider"
            @input="updateCineSpeed"
            title="Ajustar velocidade do cine"
          />
          <div class="speed-presets">
            <button @click="setCineSpeed(0.5)" class="speed-preset-btn">0.5x</button>
            <button @click="setCineSpeed(1)" class="speed-preset-btn">1x</button>
            <button @click="setCineSpeed(2)" class="speed-preset-btn">2x</button>
            <button @click="setCineSpeed(5)" class="speed-preset-btn">5x</button>
          </div>
        </div>
      </div>
      
      <!-- Status do cine -->
      <div class="cine-status-section">
        <div class="status-item">
          <span class="status-label">Status:</span>
          <span :class="['status-value', { active: isCineActive }]">
            {{ isCineActive ? 'Reproduzindo' : 'Parado' }}
          </span>
        </div>
        <div class="status-item">
          <span class="status-label">Imagens:</span>
          <span class="status-value">{{ imageIds.length }}</span>
        </div>
        <div class="status-item">
          <span class="status-label">Atual:</span>
          <span class="status-value">{{ (isNaN(currentImageIndex) ? 0 : currentImageIndex) + 1 }}/{{ imageIds.length }}</span>
        </div>
      </div>
    </div>

    <div :class="['main-container', { 'has-share-banner': isSharedView }]">
      <div ref="seriesListEl" :class="['series-panel', { 'collapsed': isSeriesPanelCollapsed, 'show': isSeriesPanelShow }]">
        <h5 class="mb-4">Séries do Exame</h5>
        <div v-if="isLoadingSeriesList" class="loading-text">
          Carregando séries...
        </div>
        <div v-else v-for="series in seriesData" :key="series.id" class="series-item" @click="loadSeries(series)">
          <img :src="series.thumbnail || 'https://via.placeholder.com/250/333/FFFFFF?text=Sem+Thumb'" :alt="series.description">
          <p>{{ series.description }}</p>
        </div>
        <div v-if="!isLoadingSeriesList && seriesData.length === 0" class="loading-text">
          Nenhuma série encontrada.
        </div>
      </div>
      
      <div v-if="isSeriesPanelShow" class="overlay active" @click="toggleSeriesPanel"></div>

      <div 
        :class="['viewer-container', { 'viewer-with-panel': (showLaudoPanel || (showPrintSeriesModal && canPrintSeries)) && shouldShowLaudoButton }]" 
        :style="{ marginRight: viewerMarginRight }"
        @transitionend="onViewerTransitionEnd"
      >
        <div v-if="isLoadingImage || isLoadingSeries" class="loading-overlay">
          <div class="loading-text">
            <div v-if="isLoadingSeries" class="series-loading">
              <div class="loading-spinner"></div>
              <div class="loading-message">Carregando série...</div>
              <div class="loading-subtitle">Aguarde enquanto as imagens são processadas</div>
            </div>
            <div v-else class="image-loading">
              <div class="loading-spinner"></div>
              <div class="loading-message">Carregando imagem...</div>
            </div>
          </div>
        </div>

        <div :class="['viewer', { 'hidden': currentViewMode !== 'single' }]" ref="singleViewerEl">
          <div ref="dicomImageEl" class="w-full h-full relative">
             <div ref="watermarkEl" class="watermark"></div>
          </div>
          
          <div id="imageSliderContainer" v-if="imageIds.length > 1">
            <div 
              id="progressBarContainer" 
              @mousedown="handleMouseDown" 
              @mousemove="handleMouseMove" 
              @mouseup="handleMouseUp" 
              @mouseleave="handleMouseLeave" 
              @touchstart="handleTouchStart" 
              @touchmove="handleTouchMove" 
              @touchend="handleTouchEnd"
            >
              <div class="preloading-progress-bar" :style="{ width: preloadingProgressWidth }"></div>
              <div id="progressBar" :style="{ width: progressBarWidth }"></div>
              <div id="progressHandle" :style="{ left: progressBarWidth }"></div>
            </div>
          </div>
        </div>
        
        <div :class="['mpr-container', { 'active': currentViewMode === 'mpr' }]" ref="mprContainerEl">
           </div>

        <div :class="['measurement-panel', { 'active': measurements.length > 0 }]">
           <h6>Medições</h6>
           <div id="measurementList">
              <div v-for="(measurement, index) in measurements" :key="index" class="measurement-item">
                  {{ index + 1 }}. {{ measurement.toolType }}: {{ measurement.text || 'N/A' }}
              </div>
           </div>
        </div>

        <div :class="['presets-panel', { 'active': showPresetsPanel }]">
          <h6>Presets de Janelamento</h6>
          <button v-for="(preset, key) in windowPresets" :key="key" class="preset-btn" @click="applyWindowPreset(key)">
              {{ key.charAt(0).toUpperCase() + key.slice(1) }}
          </button>
        </div>
      </div>
      
      <!-- [NOVO] Botão fixo para abrir o painel do laudo -->
      <button 
        v-if="shouldShowLaudoButton"
        class="laudo-panel-toggle-btn"
        :class="{ 'disabled': isLaudoButtonDisabled }"
        @mousedown="handleButtonMouseDown"
        :aria-expanded="showLaudoPanel"
        title="Abrir/Fechar Laudo - Arrastar para redimensionar"
        :style="showLaudoPanel ? { right: `${panelWidth}vw`, transition: isResizingPanel ? 'none' : 'right 0.3s ease' } : {}"
        :disabled="isLaudoButtonDisabled"
      >
        <div class="flex flex-col items-center">
          <FileText :size="20" class="rotate-icon mb-2" />
          <span class="text-xs mt-1 writing-mode-vertical font-bold tracking-wider text-white">LAUDO</span>
          <ChevronsLeftRightEllipsis :size="20" class="mt-2"/>
        </div>
      </button>

      <!-- [NOVO] Botão fixo para impressão de séries -->
      <button 
        v-if="shouldShowPrintButton"
        class="print-series-toggle-btn"
        @mousedown="handlePrintButtonMouseDown"
        :aria-expanded="showPrintSeriesModal"
        title="Abrir/Fechar Impressão - Arrastar para redimensionar"
        :style="showPrintSeriesModal ? { right: `${printPanelWidth}vw`, transition: isResizingPrintPanel ? 'none' : 'right 0.3s ease' } : {}"
      >
        <div class="flex flex-col items-center">
          <Printer :size="20" class="rotate-icon mb-2" />
          <span class="text-xs mt-1 writing-mode-vertical font-bold tracking-wider text-white">IMPRIMIR</span>
          <ChevronsLeftRightEllipsis :size="20" class="mt-2"/>
        </div>
      </button>
      
      <!-- [NOVO] Painel lateral do laudo -->
      <transition name="slide-laudo-panel">
        <div v-if="showLaudoPanel && shouldShowLaudoButton" class="laudo-panel-drawer" :style="{ width: `${panelWidth}vw` }">
          <LaudoModal 
            :isVisible="true" 
            :paciente="pacienteAtual" 
            modo-painel
            @close="showLaudoPanel = false"
            @dados-paciente-carregados="atualizarDadosPaciente"
          />
        </div>
      </transition>

      <!-- [NOVO] Modal de impressão de séries -->
      <transition name="slide-print-panel">
        <div v-if="showPrintSeriesModal && shouldShowLaudoButton && canPrintSeries" class="print-panel-drawer" :style="{ width: `${printPanelWidth}vw` }">
          <PrintSeriesModal
            :isVisible="true"
            :availableImages="currentSeriesImages"
            :currentImageIndex="currentImageIndex"
            :paciente="pacienteAtual"
            modo-painel
            @close="showPrintSeriesModal = false"
            ref="printSeriesModalRef"
            @solicitar-imagem-atual="handleSolicitarImagemAtual"
          />
        </div>
      </transition>
    </div>
  </template>


<script setup>
import { ref, onMounted, onUnmounted, computed, watch } from 'vue';
import { useRoute } from 'vue-router';

// Cornerstone and dependencies
import cornerstone from 'cornerstone-core';
import cornerstoneTools from 'cornerstone-tools';
import cornerstoneMath from 'cornerstone-math';
import cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader';
import cornerstoneWebImageLoader from 'cornerstone-web-image-loader';
import * as dicomParser from 'dicom-parser';
import Hammer from 'hammerjs';

// Lucide Icons
import { 
PanelLeft, Square, LayoutGrid, Layers, Hand, ZoomIn, SunMoon, RotateCw,
Ruler, Spline, Circle, RectangleHorizontal, MousePointer2, Eraser,
Palette, Contrast, FlipHorizontal, FlipVertical, Undo2, Expand, FileText, ChevronsLeftRightEllipsis, Printer, ExternalLink, PenTool
} from 'lucide-vue-next';

// [NOVO] Importar o LaudoModal.vue
import LaudoModal from '@/components/LaudoModal.vue';

// [NOVO] Importar o PrintSeriesModal.vue
import PrintSeriesModal from '@/components/PrintSeriesModal.vue';

// [NOVO] Importar o userStore
import { useUserStore } from '@/stores/userStore';

// --- Refs for DOM Elements ---
const dicomImageEl = ref(null);
const watermarkEl = ref(null);
const seriesListEl = ref(null);
const mprContainerEl = ref(null);

// --- Reactive State ---
const seriesData = ref([]);
const imageIds = ref([]);
const currentImageIndex = ref(0);
const measurements = ref([]);
const currentViewMode = ref('single');
const activeTool = ref('StackScroll');
const isSeriesPanelCollapsed = ref(true);
const isSeriesPanelShow = ref(false);
const showPresetsPanel = ref(false);
const isDraggingSlider = ref(false);
const isLoadingSeriesList = ref(true);
const isLoadingImage = ref(false);
const preloadingProgress = ref(0);

// [NOVO] Flag para controlar se é a primeira inicialização
const isFirstInitialization = ref(true);

// [NOVO] Estado para controlar carregamento de série com tempo mínimo
const isLoadingSeries = ref(false);
const seriesLoadingStartTime = ref(0);
const minSeriesLoadingTime = 2000; // 2 segundos mínimo

// [NOVO] Estado para preservar viewport entre trocas de imagem
const savedViewport = ref(null);

// [NOVO] Estado para controlar a aba lateral do laudo
const showLaudoPanel = ref(false);

// [NOVO] Estado para redimensionamento do painel
const isResizingPanel = ref(false);
const panelWidth = ref(38); // Largura inicial em vw
const minPanelWidth = 25; // Largura mínima em vw
const maxPanelWidth = 80; // Largura máxima em vw

// [NOVO] Estado para controlar o modal de impressão de séries
const showPrintSeriesModal = ref(false);

// [NOVO] Estado para redimensionamento do modal de impressão
const printPanelWidth = ref(38); // Largura inicial em vw
const isResizingPrintPanel = ref(false);

// [NOVO] Debounce para redimensionamento do canvas
let resizeTimeout = null;

// [NOVO] Estado para controlar se é a primeira vez que os painéis são abertos
const isFirstPanelOpen = ref(true);

// [NOVO] Dados reais do paciente carregados da API
const pacienteAtual = ref(null);



// [NOVO] Ref para o modal de impressão
const printSeriesModalRef = ref(null);

// [NOVO] UserStore para verificar permissões
const userStore = useUserStore();



// [NOVO] Capturar parâmetros da URL para compartilhamento
const route = useRoute();
const shareToken = ref(route.query.token || null);
const shareAccessionNumber = ref(route.query.accession_number || null);


// [NOVO] Estado para dados do compartilhamento
const shareData = ref(null);
const isSharedView = ref(false);

// [NOVO] Função para verificar se o token está expirado
const isTokenExpired = computed(() => {
  if (!shareData.value || !shareData.value.expires_at) {
    return false;
  }
  
  const expiresAt = new Date(shareData.value.expires_at);
  const now = new Date();
  const isExpired = now > expiresAt;
  
  return isExpired;
});

// [NOVO] Função para formatar a data de expiração
const formatExpirationDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleString('pt-BR');
};

// [NOVO] Função para fechar o modal de expiração
const closeExpiredModal = () => {
  // Redirecionar para a tela de login
  window.location.href = '/';
};

// [NOVO] Função para verificar se o userStore está inicializado corretamente
const checkUserStoreInitialization = () => {
  // Se o userStore não tem permissões mas está autenticado, tentar recarregar
  if (userStore.autenticado && userStore.permissions.length === 0) {
    // Aqui você poderia chamar uma função para recarregar as permissões
  }
};

// [NOVO] Computed para verificar se o usuário tem permissão para imprimir
const canPrintSeries = computed(() => {
  const hasPermission = userStore.permissions.includes('Pacs.create_pacs_series_print');
  return hasPermission;
});

// --- Computed Properties ---
const progressBarWidth = computed(() => {
  if (imageIds.value.length <= 1) return '0%';
  return (currentImageIndex.value / (imageIds.value.length - 1)) * 100 + '%';
});

const preloadingProgressWidth = computed(() => `${preloadingProgress.value}%`);

// [NOVO] Detectar se está sendo usado dentro de um iframe (como no LaudoModal)
const isEmbeddedInIframe = computed(() => {
  try {
      // Verificar se está dentro de um iframe
      return window !== window.top;
  } catch (error) {
      // Se não conseguir acessar window.top, provavelmente está em um iframe
      return true;
  }
});

// [NOVO] Computed para mostrar ou não o botão do laudo
const shouldShowLaudoButton = computed(() => {
  const result = !isEmbeddedInIframe.value;
  // Não mostrar o botão se estiver embutido em iframe (como no LaudoModal)
  return result;
});

// [NOVO] Computed para a condição completa do botão de impressão
const shouldShowPrintButton = computed(() => {
  const result = shouldShowLaudoButton.value && canPrintSeries.value;
  return result;
});

// [NOVO] Computed para obter as imagens da série atual
const currentSeriesImages = computed(() => {
  if (!imageIds.value.length) return [];
  
  return imageIds.value.map((imageId, index) => ({
      id: index,
      imageUrl: imageId.replace('wadouri:', ''),
      thumbnail: imageId.replace('wadouri:', '') // Em uma implementação real, você teria thumbnails separados
  }));
});

// [NOVO] Computed para calcular a margem direita do viewer
const viewerMarginRight = computed(() => {
  if (!shouldShowLaudoButton.value) return '0vw';
  
  let margin = 0;
  
  if (showLaudoPanel.value) {
      margin = Math.max(margin, panelWidth.value);
  }
  
  if (showPrintSeriesModal.value && canPrintSeries.value) {
      margin = Math.max(margin, printPanelWidth.value);
  }
  
  return margin > 0 ? `${margin}vw` : '0vw';
});

// [NOVO] Watcher para redimensionar o canvas quando qualquer painel mudar
watch([viewerMarginRight], () => {
  // Só redimensionar se o botão estiver visível
  if (shouldShowLaudoButton.value) {
      // [NOVO] Se for a primeira vez que um painel é aberto, aguardar mais tempo
      if (isFirstPanelOpen.value && (showLaudoPanel.value || (showPrintSeriesModal.value && canPrintSeries.value))) {
          isFirstPanelOpen.value = false;
          
          // Redimensionar com delays maiores na primeira vez
          setTimeout(() => {
              resizeCornerstoneCanvas();
          }, 100);
          
          setTimeout(() => {
              resizeCornerstoneCanvas();
          }, 400);
          
          setTimeout(() => {
              resizeCornerstoneCanvas();
          }, 800);
      } else {
          // Usar a função específica para mudanças de margem
          forceResizeOnMarginChange();
      }
  }
});

// [NOVO] Watcher para detectar mudanças no paciente e forçar carregamento no LaudoModal
watch([pacienteAtual], (novoPaciente) => {
  if (novoPaciente && showLaudoPanel.value) {
      // Forçar um tick para garantir que o LaudoModal receba os dados atualizados
      setTimeout(() => {
          // Dados atualizados enviados
      }, 100);
  }
});

// [NOVO] Watcher para monitorar expiração do token
watch([isTokenExpired], (newValue) => {
  if (newValue && isSharedView.value) {
    // Limpar dados das imagens quando o token expirar
    seriesData.value = [];
    imageIds.value = [];
    currentImageIndex.value = 0;
  }
});

// [NOVO] Watcher adicional para detectar mudanças nos painéis
watch([showLaudoPanel, showPrintSeriesModal], () => {
  if (shouldShowLaudoButton.value) {
      // Redimensionar quando um painel é aberto ou fechado
      setTimeout(() => {
          resizeCornerstoneCanvas();
      }, 100);
      
      setTimeout(() => {
          resizeCornerstoneCanvas();
      }, 300);
  }
});

// [NOVO] Watcher para parar o cine quando trocar de série
watch([imageIds], () => {
  if (isCineActive.value) {
    stopCine();
  }
});

// [NOVO] Watcher para fechar o menu do cine quando trocar de série
watch([imageIds], () => {
  showCineMenu.value = false;
});

// [NOVO] Watcher para monitorar mudanças no userStore
watch(() => userStore.permissions, () => {
  // Permissões mudaram
}, { deep: true });

watch(() => userStore.autenticado, () => {
  if (userStore.autenticado) {
      // Usuário autenticado
  }
});

watch(canPrintSeries, () => {
  // canPrintSeries mudou
});

watch(shouldShowPrintButton, () => {
  // shouldShowPrintButton mudou
});

// --- Windowing Presets ---
const windowPresets = {
  default: { windowWidth: 400, windowCenter: 40 },
  lung: { windowWidth: 1500, windowCenter: -600 },
  bone: { windowWidth: 2000, windowCenter: 300 },
  brain: { windowWidth: 100, windowCenter: 50 },
  abdomen: { windowWidth: 350, windowCenter: 50 },
  mediastinum: { windowWidth: 350, windowCenter: 50 }
};

// --- Lifecycle Hooks ---
onMounted(async () => {
  // [NOVO] Verificar se é uma visualização compartilhada
  if (shareToken.value && shareAccessionNumber.value) {
    isSharedView.value = true;
    
    try {
      // Verificar o token de compartilhamento
      const response = await fetch(`/api/v1/schedules/verify-share/${shareToken.value}/`);
      if (!response.ok) {
        throw new Error('Token de compartilhamento inválido ou expirado');
      }
      
      const tokenData = await response.json();
      shareData.value = tokenData;
      
      // [NOVO] Verificar se o token expirou após carregar os dados
      if (isTokenExpired.value) {
        return; // Não carregar as imagens se o token expirou
      }
      
      // Carregar as imagens usando o accession_number do compartilhamento
      initCornerstone();
      await fetchExamInfoAndPopulateSeries();
      
    } catch (error) {
      console.error('ShareViewer: Erro ao verificar token:', error);
      alert('Link de compartilhamento inválido ou expirado');
      return;
    }
  } else {
    // [NOVO] Verificar inicialização do userStore apenas para visualização normal
    checkUserStoreInitialization();
    
    // Carregamento normal do viewer
    initCornerstone();
    fetchExamInfoAndPopulateSeries();
  }
  
      const dicomElement = dicomImageEl.value;
    if (dicomElement) {
        dicomElement.addEventListener('cornerstonenewimage', handleNewImageEvent);
        window.addEventListener('resize', handleResize);
        // Listener para mudanças de fullscreen (F11, ESC, etc.)
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        

    }
  
  // [NOVO] Adicionar listener para detectar entrada em iframes
  document.addEventListener('mouseover', (event) => {
      if (event.target.tagName === 'IFRAME') {
          handleIframeMouseEnter();
      }
  });
  
  // [NOVO] Adicionar listener para fechar o menu do cine quando clicar fora
  document.addEventListener('click', (event) => {
    const cineDropdown = document.querySelector('.cine-dropdown-container');
    const cineMenuFixed = document.querySelector('.cine-dropdown-menu-fixed');
    if (showCineMenu.value && cineDropdown && !cineDropdown.contains(event.target) && !cineMenuFixed?.contains(event.target)) {
      showCineMenu.value = false;
    }
  });
  
  // [NOVO] Forçar redimensionamento após a página carregar completamente
  setTimeout(() => {
      resizeCornerstoneCanvas();
  }, 1000);
  
      // [NOVO] Redimensionar novamente após um tempo maior
    setTimeout(() => {
        resizeCornerstoneCanvas();
    }, 2000);
    
    // [NOVO] Garantir que StackScroll esteja ativo após inicialização completa
    setTimeout(() => {
        if (dicomImageEl.value && cornerstone.getImage(dicomImageEl.value)) {
            cornerstoneTools.setToolActive('StackScroll', { mouseButtonMask: 1 });
            activeTool.value = 'StackScroll';
            // [NOVO] Marcar que não é mais a primeira inicialização após o timeout
            isFirstInitialization.value = false;
        }
    }, 3000);
  
  // [NOVO] Garantir que o elemento seja habilitado após a renderização
  setTimeout(() => {
    if (dicomImageEl.value && !dicomImageEl.value.classList.contains('cornerstone-enabled')) {
      cornerstone.enable(dicomImageEl.value);
    }
  }, 500);
});

onUnmounted(() => {
    const dicomElement = dicomImageEl.value;
    if (dicomElement) {
        dicomElement.removeEventListener('cornerstonenewimage', handleNewImageEvent);
        window.removeEventListener('resize', handleResize);
        document.removeEventListener('fullscreenchange', handleFullscreenChange);
    }
  

  
  // [NOVO] Limpar variáveis de navegação
  if (navigationTimeout) {
      clearTimeout(navigationTimeout);
      navigationTimeout = null;
  }
  currentNavigationPromise = null;
  lastNavigationIndex = -1;
  // let isScrolling = false; // [NOVO] Variável global para controlar scroll (REMOVIDO)
  
  // [NOVO] Limpar timeout de redimensionamento
  if (resizeTimeout) {
      clearTimeout(resizeTimeout);
      resizeTimeout = null;
  }
  
  // [NOVO] Limpar listeners de arraste se ainda estiverem ativos
  document.removeEventListener('mousemove', handleButtonMouseMove);
  document.removeEventListener('mouseup', handleButtonMouseUp);
  document.removeEventListener('mouseleave', handleButtonMouseLeave);
  document.removeEventListener('mousemove', handlePrintButtonMouseMove);
  document.removeEventListener('mouseup', handlePrintButtonMouseUp);
  document.removeEventListener('mouseleave', handlePrintButtonMouseLeave);
  
  // [NOVO] Parar o cine quando sair da página
  stopCine();
});

function handleResize() {
  resizeCornerstoneCanvas();
}

function handleFullscreenChange() {
  // Reset quando há mudança no estado de fullscreen
  setTimeout(() => {
      resizeCornerstoneCanvas();
  }, 200);
}

// --- Data Fetching & Pre-loading ---

// [NOVO] Função para pré-carregar todas as imagens de todas as séries
function preloadAllSeriesImages(seriesList) {
  // Cria uma lista única de todos os imageIds de todas as séries
  const allImageIds = [];
  let totalImages = 0;
  
  seriesList.forEach((serie, serieIndex) => {
    if (serie.imageUrls && serie.imageUrls.length > 0) {
      serie.imageUrls.forEach((url, imageIndex) => {
        const imageId = `wadouri:${url}`;
        allImageIds.push({
          imageId,
          serieIndex,
          imageIndex,
          serieDescription: serie.description
        });
        totalImages++;
      });
    }
  });
  
  if (totalImages === 0) {
    return;
  }
  
  // [NOVO] Função para carregar uma imagem individual
  const loadImage = async (imageData) => {
    try {
      await cornerstone.loadAndCacheImage(imageData.imageId);
    } catch (error) {
      console.warn(`ShareViewer: Falha ao carregar imagem ${imageData.imageId}:`, error.message);
    }
  };
  
  // [NOVO] Carregar todas as imagens em paralelo sem limite
  Promise.allSettled(allImageIds.map(loadImage))
    .catch((error) => {
      console.error('ShareViewer: Erro no preload:', error);
    });
}

async function fetchExamInfoAndPopulateSeries() {
isLoadingSeriesList.value = true;
try {
  // [NOVO] Usar accession_number do compartilhamento se disponível
  let accessionNumber;
  if (isSharedView.value && shareAccessionNumber.value) {
    accessionNumber = shareAccessionNumber.value;
  } else {
    const params = new URLSearchParams(window.location.search);
    accessionNumber = params.get('accession_number');
  }
  
  if (!accessionNumber) {
    alert('Accession Number (accession_number) não encontrado nos parâmetros da URL.');
    return;
  }
  
  const response = await fetch(`/api/v1/pacs/public/get_exam_info_shared?accession_number=${accessionNumber}&share_token=${shareToken.value}`);
  if (!response.ok) {
    throw new Error(`Erro na rede: ${response.statusText}`);
  }
  
  const data = await response.json();
  if (data.error) {
    throw new Error(data.error);
  }
  
  // [NOVO] Criar dados básicos do paciente baseados no accession_number
  // Os dados completos serão carregados pelo LaudoModal.vue
  pacienteAtual.value = {
    nome: data.info_exame?.nome || 'Carregando...',
    exame: data.info_exame?.tipoExame || 'Carregando...',
    idPaciente: data.info_exame?.patientID?.toString() || 'Carregando...',
    numAcesso: accessionNumber,
    data: data.info_exame?.data || new Date().toISOString(),
    numero: accessionNumber,
    appointmentId: null, // Será atualizado pelo LaudoModal
    sexo: data.info_exame?.sexo || 'N/A',
    dataNasc: data.info_exame?.dataNasc || null,
    cpf: 'N/A',
    medRef: data.info_exame?.medSol || 'N/A',
    mod: data.info_exame?.modalidade || 'N/A'
  };
  
  seriesData.value = (data.series || []).map((serie, idx) => ({
    id: serie.seriesUID || `serie${idx + 1}`,
    description: serie.seriesDescricao || `Série ${idx + 1}`,
    thumbnail: serie.images[0]?.thumbnail_url,
    imageUrls: serie.images.map(img => img.image_url)
  }));

      if (seriesData.value.length > 0) {
        // [NOVO] Iniciar carregamento inicial com tempo mínimo
        isLoadingSeries.value = true;
        seriesLoadingStartTime.value = Date.now();
        
        await loadSeries(seriesData.value[0]);
        
        // [NOVO] Carregar TODAS as imagens de TODAS as séries imediatamente
        preloadAllSeriesImages(seriesData.value);
        
        // [NOVO] Também carregar todas as imagens da série atual de forma agressiva
        setTimeout(() => {
          if (imageIds.value.length > 0) {
            startPreloading(imageIds.value);
          }
        }, 500);
      }

} catch (error) {
  alert(`Não foi possível carregar o exame: ${error.message}`);
} finally {
  isLoadingSeriesList.value = false;
}
}

function startPreloading(imageIdsToLoad) {
  let loadedImageCount = 0;
  const totalImages = imageIdsToLoad.length;
  if (totalImages === 0) return;

  // [NOVO] Resetar progresso
  preloadingProgress.value = 0;
  
  const loadImage = async (imageId) => {
    try {
      await cornerstone.loadAndCacheImage(imageId);
      loadedImageCount++;
      preloadingProgress.value = (loadedImageCount / totalImages) * 100;
    } catch (error) {
      loadedImageCount++;
      preloadingProgress.value = (loadedImageCount / totalImages) * 100;
      console.warn(`ShareViewer: Falha ao carregar imagem ${imageId}:`, error.message);
    }
  };
  
  // [NOVO] Carregar todas as imagens em paralelo sem delays
  Promise.allSettled(imageIdsToLoad.map(loadImage))
    .catch((error) => {
      console.error('ShareViewer: Erro no preload da série atual:', error);
    });
}





// --- Cornerstone Methods ---
function initCornerstone() {
  // [CRÍTICO] Configurar externals ANTES de qualquer uso
  try {
    cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
    cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
    cornerstoneWebImageLoader.external.cornerstone = cornerstone;
  } catch (error) {
    console.error('ShareViewer: Erro ao configurar externals:', error);
  }
  
  // [CRÍTICO] Inicializar WebWorkerManager
  try {
    const config = {
        maxWebWorkers: navigator.hardwareConcurrency || 1,
        startWebWorkersOnDemand: true,
        webWorkerPath: 'https://unpkg.com/cornerstone-wado-image-loader@4.1.2/dist/cornerstoneWADOImageLoaderWebWorker.min.js',
        taskConfiguration: {
            'decodeTask': {
                codecsPath: 'https://unpkg.com/cornerstone-wado-image-loader@4.1.2/dist/cornerstoneWADOImageLoaderCodecs.min.js'
            }
        }
    };
    cornerstoneWADOImageLoader.webWorkerManager.initialize(config);
  } catch (error) {
    // Ignorar erro se já inicializado
  }

  // [CRÍTICO] Configurar Cornerstone Tools externals
  try {
    cornerstoneTools.external.cornerstone = cornerstone;
    cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
    cornerstoneTools.external.Hammer = Hammer;
  } catch (error) {
    // Ignorar erro se já configurado
  }

  // [CRÍTICO] Inicializar Cornerstone Tools
  try {
    cornerstoneTools.init();
  } catch (error) {
    // Ignorar erro se já inicializado
  }

  // [CRÍTICO] Habilitar o elemento
  try {
    cornerstone.enable(dicomImageEl.value);
  } catch (error) {
    // Ignorar erro se já habilitado
  }

  // [NOVO] Otimizar canvas para múltiplas leituras
  try {
    // [NOVO] Interceptar a criação de canvas globalmente
    const originalGetContext = HTMLCanvasElement.prototype.getContext;
    HTMLCanvasElement.prototype.getContext = function(contextType, contextAttributes) {
      if (contextType === '2d' && (!contextAttributes || !contextAttributes.willReadFrequently)) {
        contextAttributes = { ...contextAttributes, willReadFrequently: true };
      }
      return originalGetContext.call(this, contextType, contextAttributes);
    };
    
    const canvas = dicomImageEl.value.querySelector('canvas');
    if (canvas) {
      // Otimizar o canvas principal para múltiplas leituras
      canvas.getContext('2d', { willReadFrequently: true });
      
      // [NOVO] Observar mudanças no canvas para reaplicar a otimização
      const observer = new MutationObserver(() => {
        const newCanvas = dicomImageEl.value.querySelector('canvas');
        if (newCanvas && !newCanvas.dataset.optimized) {
          newCanvas.getContext('2d', { willReadFrequently: true });
          newCanvas.dataset.optimized = 'true';
        }
      });
      
      observer.observe(dicomImageEl.value, { 
        childList: true, 
        subtree: true 
      });
      
      // Marcar como otimizado
      canvas.dataset.optimized = 'true';
    }
    
  } catch (error) {
    // Ignorar erro ao otimizar canvas
  }

  // [CRÍTICO] Adicionar ferramentas
  const tools = [
      'Pan', 'Zoom', 'Wwwc', 'StackScrollMouseWheel', 'StackScroll', 'Rotate',
      'Length', 'Angle', 'EllipticalRoi', 'RectangleRoi', 'FreehandRoi', 'ArrowAnnotate', 'Eraser', 'Magnify'
  ];
  
  tools.forEach(toolName => {
    try {
      cornerstoneTools.addTool(cornerstoneTools[toolName + 'Tool']);
    } catch (error) {
      // Ignorar erro se ferramenta já adicionada
    }
  });

  // [CRÍTICO] Configurar ferramentas ativas
  try {
    cornerstoneTools.setToolActive('StackScroll', { mouseButtonMask: 1 });
    cornerstoneTools.setToolActive('Zoom', { mouseButtonMask: 2 });
    
    // [NOVO] Adicionar Stack State Manager para gerenciar o stack
    cornerstoneTools.addStackStateManager(dicomImageEl.value, ['stack']);
    
    // [NOVO] Ativar a ferramenta StackScrollMouseWheel
    cornerstoneTools.setToolActive('StackScrollMouseWheel', {});
    
    // [NOVO] Pré-inicializar ferramentas pesadas para evitar congelada
    setTimeout(() => {
      try {
        // Pré-inicializar ferramentas de medição
        ['Length', 'Angle', 'EllipticalRoi', 'RectangleRoi', 'FreehandRoi', 'ArrowAnnotate'].forEach(toolName => {
          cornerstoneTools.setToolActive(toolName, { mouseButtonMask: 1 });
          cornerstoneTools.setToolDisabled(toolName);
        });
      } catch (error) {
        // Ignorar erro ao pré-inicializar ferramentas
      }
    }, 1000);
    
  } catch (error) {
    // Ignorar erro se ferramentas já configuradas
  }

  // [CRÍTICO] Adicionar event listeners
  const measurementEvents = [
    'cornerstonetoolsmeasurementadded',
    'cornerstonetoolsmeasurementmodified', 
    'cornerstonetoolsmeasurementremoved'
  ];
  
  measurementEvents.forEach(eventType => {
    try {
      if (dicomImageEl.value) {
        dicomImageEl.value.addEventListener(eventType, handleMeasurementEvent);
      }
    } catch (error) {
      // Ignorar erro se event listener já adicionado
    }
  });
  
  // [NOVO] Listener para preservar medições durante operações de navegação
  try {
    if (dicomImageEl.value) {
      dicomImageEl.value.addEventListener('cornerstoneimagerendered', () => {
        // Forçar atualização das medições após renderização
        setTimeout(() => {
          handleMeasurementEvent();
        }, 50);
      });
    }
  } catch (error) {
    // Ignorar erro se event listener já adicionado
  }
}

function handleMeasurementEvent() {
  // [NOVO] Usar requestAnimationFrame para não bloquear a thread principal
  requestAnimationFrame(() => {
    try {
      const toolStateManager = cornerstoneTools.globalImageIdSpecificToolStateManager;
      const image = cornerstone.getImage(dicomImageEl.value);
      if (!image) return;

      const imageId = image.imageId;
      const toolState = toolStateManager.getImageIdToolState(imageId);

      if (!toolState) {
        measurements.value = [];
        return;
      }
      
      const allMeasurements = [];
      Object.keys(toolState).forEach(toolType => {
        const toolData = toolState[toolType];
        if (toolData && Array.isArray(toolData.data)) {
          allMeasurements.push(...toolData.data);
        }
      });
      measurements.value = allMeasurements;

    } catch (error) {
      // Erro silencioso durante troca de imagem
    }
  });
}

async function loadSeries(series) {
  if (!series.imageUrls || series.imageUrls.length === 0) {
      alert('Esta série não contém imagens para carregar.');
      return;
  }
  
  // [NOVO] Verificar se já está carregando (para evitar duplicação no carregamento inicial)
  const isInitialLoad = !isLoadingSeries.value;
  
  if (isInitialLoad) {
    // [NOVO] Iniciar carregamento de série com tempo mínimo apenas se não estiver carregando
    isLoadingSeries.value = true;
    seriesLoadingStartTime.value = Date.now();
  }
  
  // [NOVO] Salvar a ferramenta ativa antes de trocar de série
  const currentActiveTool = activeTool.value;
  
  // [NOVO] Limpar viewport salvo ao carregar nova série
  savedViewport.value = null;
  
  // [CRÍTICO] Garantir que o Cornerstone esteja inicializado
  if (!dicomImageEl.value) {
    console.error('ShareViewer: Elemento de imagem não disponível');
    return;
  }
  
  // Verificar se o elemento já tem a classe cornerstone-enabled
  if (!dicomImageEl.value.classList.contains('cornerstone-enabled')) {
    cornerstone.enable(dicomImageEl.value);
  }
  
  preloadingProgress.value = 0;
  imageIds.value = series.imageUrls.map(url => `wadouri:${url}`);
  
  await loadAndDisplayImage(0);
  
  // [NOVO] Função para finalizar o carregamento respeitando o tempo mínimo
  const finishSeriesLoading = () => {
    const elapsedTime = Date.now() - seriesLoadingStartTime.value;
    const remainingTime = Math.max(0, minSeriesLoadingTime - elapsedTime);
    
    setTimeout(() => {
      isLoadingSeries.value = false;
      // [NOVO] Também limpar isLoadingImage quando a série terminar de carregar
      isLoadingImage.value = false;
    }, remainingTime);
  };
  
  // [NOVO] Restaurar a ferramenta ativa após carregar a nova série
  setTimeout(() => {
    if (currentActiveTool && currentActiveTool !== 'StackScroll') {
      activateTool(currentActiveTool);
    } else {
      // Se a ferramenta era StackScroll ou não havia ferramenta, manter StackScroll como padrão
      cornerstoneTools.setToolActive('StackScroll', { mouseButtonMask: 1 });
      activeTool.value = 'StackScroll';
    }
    
    // [NOVO] Garantir que não é mais a primeira inicialização após trocar de série
    isFirstInitialization.value = false;
    
    // [NOVO] Finalizar carregamento respeitando o tempo mínimo
    finishSeriesLoading();
  }, 200);
  
  // [NOVO] Iniciar preloading da nova série de forma assíncrona
  setTimeout(() => {
      startPreloading(imageIds.value);
  }, 200);
  
  if(window.innerWidth <= 768 && isSeriesPanelShow.value){
      toggleSeriesPanel();
  }
  
  // [NOVO] Redimensionar o canvas após carregar uma série
  setTimeout(() => {
      resizeCornerstoneCanvas();
  }, 500);
}

async function loadAndDisplayImage(index) {
  if (index < 0 || index >= imageIds.value.length) return;
  
  // [NOVO] Salvar viewport atual antes de trocar de imagem
  let savedViewport = null;
  if (dicomImageEl.value && currentImageIndex.value !== index) {
    try {
      const currentViewport = cornerstone.getViewport(dicomImageEl.value);
      if (currentViewport) {
        savedViewport = {
          scale: currentViewport.scale,
          translation: { ...currentViewport.translation },
          voi: { ...currentViewport.voi },
          invert: currentViewport.invert,
          hflip: currentViewport.hflip,
          vflip: currentViewport.vflip,
          rotation: currentViewport.rotation
        };
      }
    } catch (error) {
      // Erro silencioso ao salvar viewport
    }
  }
  
  // Garante que o índice reativo esteja sincronizado
  currentImageIndex.value = index;

  // [NOVO] Só definir loading se não estiver já carregando uma série
  if (!isLoadingSeries.value) {
    isLoadingImage.value = true;
  }
  const imageId = imageIds.value[index];
  
  try {
      // [CRÍTICO] Verificar se o elemento está habilitado antes de carregar a imagem
      if (!dicomImageEl.value) {
        throw new Error('Elemento de imagem não encontrado');
      }
      
      // Verificar se o elemento já tem a classe cornerstone-enabled
      if (!dicomImageEl.value.classList.contains('cornerstone-enabled')) {
        cornerstone.enable(dicomImageEl.value);
      }
      
      // [NOVO] Carregar imagem de forma completamente assíncrona
      const image = await cornerstone.loadAndCacheImage(imageId);
      
      // [NOVO] Usar requestAnimationFrame para não bloquear a thread principal
      requestAnimationFrame(() => {
        try {
          cornerstone.displayImage(dicomImageEl.value, image);
          updateWatermark(image);

          // [NOVO] Definir o stack seguindo o padrão do exemplo
          const stack = {
              currentImageIdIndex: index,
              imageIds: imageIds.value
          };
          
          // [NOVO] Limpar e adicionar o stack state
          cornerstoneTools.clearToolState(dicomImageEl.value, 'stack');
          cornerstoneTools.addToolState(dicomImageEl.value, 'stack', stack);

          // [NOVO] Ativar StackScroll apenas na primeira inicialização (não ao trocar de série)
          if (index === 0 && currentImageIndex.value === 0 && isFirstInitialization.value) {
              setTimeout(() => {
                  cornerstoneTools.setToolActive('StackScroll', { mouseButtonMask: 1 });
                  activeTool.value = 'StackScroll';
                  isFirstInitialization.value = false; // Marcar que não é mais a primeira inicialização
              }, 50);
          }

          // [NOVO] Restaurar viewport salvo após carregar a nova imagem
          if (savedViewport) {
            requestAnimationFrame(() => {
              try {
                const newViewport = cornerstone.getViewport(dicomImageEl.value);
                if (newViewport) {
                  // Aplicar viewport salvo
                  newViewport.scale = savedViewport.scale;
                  newViewport.translation = { ...savedViewport.translation };
                  newViewport.voi = { ...savedViewport.voi };
                  newViewport.invert = savedViewport.invert;
                  newViewport.hflip = savedViewport.hflip;
                  newViewport.vflip = savedViewport.vflip;
                  newViewport.rotation = savedViewport.rotation;
                  
                  cornerstone.setViewport(dicomImageEl.value, newViewport);
                }
              } catch (error) {
                // Erro silencioso ao restaurar viewport
              }
            });
          }
        } catch (error) {
          console.error('ShareViewer: Erro ao exibir imagem:', error);
        }
      });

  } catch (error) {
      console.error('ShareViewer: Erro ao carregar imagem:', error);
      alert(`Erro ao carregar imagem: ${error.message}`);
  } finally {
      // [NOVO] Limpar isLoadingImage apenas se não estiver carregando uma série
      if (!isLoadingSeries.value) {
        isLoadingImage.value = false;
      }
      
      // [NOVO] Redimensionar o canvas após carregar uma imagem
      setTimeout(() => {
          resizeCornerstoneCanvas();
      }, 100);
  }
}

function handleNewImageEvent(event) {
  // [NOVO] Não processar evento se estiver carregando uma nova série
  if (isLoadingSeries.value) {
    return;
  }
  
  const newImage = event.detail.image;
  const newIndex = imageIds.value.indexOf(newImage.imageId);
  if (newIndex !== -1 && !isDraggingSlider.value) {
      currentImageIndex.value = newIndex;
      // [NOVO] Atualizar marca d'água quando a imagem muda
      updateWatermark(newImage);
  }
}

function updateWatermark(image) {
  if (!watermarkEl.value || !image.data) return;
  const patientName = image.data.string('x00100010') || 'N/A';
  const studyDate = image.data.string('x00080020') || 'N/A';
  watermarkEl.value.innerText = `Paciente: ${patientName}\nData Estudo: ${studyDate}\nImg: ${currentImageIndex.value + 1}/${imageIds.value.length}`;
}

function activateTool(toolName) {
  // [NOVO] Atualizar UI imediatamente para feedback visual
  activeTool.value = toolName;
  
  // [NOVO] Usar requestAnimationFrame para ativação não-bloqueante
  requestAnimationFrame(() => {
    try {
      // [NOVO] Configurações específicas para cada ferramenta
      if (toolName === 'Rotate') {
        // Sempre aplicar configurações de baixa sensibilidade para a rotação
        cornerstoneTools.setToolActive(toolName, { 
          mouseButtonMask: 1,
          rotationSpeed: 0.2, // Manter baixa sensibilidade
          rotationIncrement: 2, // Manter incrementos pequenos
          preventHandleOutsideImage: true, // Previne rotação fora da imagem
          mouseWheelCallback: null // Desabilita rotação por scroll do mouse
        });
      } else {
        cornerstoneTools.setToolActive(toolName, { mouseButtonMask: 1 });
      }
      
      // [NOVO] Atualizar medições de forma assíncrona
      setTimeout(() => {
        handleMeasurementEvent();
      }, 10); // Delay reduzido para 10ms
      
    } catch (error) {
      // Ignorar erro ao ativar ferramenta
    }
  });
}




// --- Toolbar and UI Methods ---
function setViewMode(mode) {
  if (mode === 'mpr') {
      alert('A visualização MPR ainda não está implementada.');
      return;
  }
  currentViewMode.value = mode; 
}
function toggleSeriesPanel() {
  if (window.innerWidth <= 768) {
      isSeriesPanelShow.value = !isSeriesPanelShow.value;
      isSeriesPanelCollapsed.value = !isSeriesPanelShow.value;
  } else {
      isSeriesPanelCollapsed.value = !isSeriesPanelCollapsed.value;
  }
}
function togglePresetsPanel() { showPresetsPanel.value = !showPresetsPanel.value; }

function applyWindowPreset(presetKey) {
  const preset = windowPresets[presetKey];
  const viewport = cornerstone.getViewport(dicomImageEl.value);
  viewport.voi.windowWidth = preset.windowWidth;
  viewport.voi.windowCenter = preset.windowCenter;
  cornerstone.setViewport(dicomImageEl.value, viewport);
  showPresetsPanel.value = false;
}

function invertColors() {
  const viewport = cornerstone.getViewport(dicomImageEl.value);
  viewport.invert = !viewport.invert;
  cornerstone.setViewport(dicomImageEl.value, viewport);
}

function flipHorizontal() {
  const viewport = cornerstone.getViewport(dicomImageEl.value);
  viewport.hflip = !viewport.hflip;
  cornerstone.setViewport(dicomImageEl.value, viewport);
}

function flipVertical() {
  const viewport = cornerstone.getViewport(dicomImageEl.value);
  viewport.vflip = !viewport.vflip;
  cornerstone.setViewport(dicomImageEl.value, viewport);
}

function resetViewport() { 
    // [NOVO] Preservar medições antes do reset
    const currentImage = cornerstone.getImage(dicomImageEl.value);
    const toolStateManager = cornerstoneTools.globalImageIdSpecificToolStateManager;
    let preservedMeasurements = {};
    
    if (currentImage) {
        const toolState = toolStateManager.getImageIdToolState(currentImage.imageId);
        if (toolState) {
            const measurementTools = ['Length', 'Angle', 'EllipticalRoi', 'RectangleRoi', 'FreehandRoi', 'ArrowAnnotate'];
            measurementTools.forEach(toolType => {
                if (toolState[toolType]) {
                    preservedMeasurements[toolType] = toolState[toolType];
                }
            });
        }
    }
    
    cornerstone.reset(dicomImageEl.value);
    
    // [NOVO] Limpar viewport salvo ao resetar
    savedViewport.value = null;
    
    // [REMOVIDO] Não restaurar medições manualmente
}

function toggleFullscreen() {
  if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().then(() => {
          // Reset após entrar em fullscreen
          setTimeout(() => {
              if(dicomImageEl.value) {
                  cornerstone.resize(dicomImageEl.value, true);
                  cornerstone.reset(dicomImageEl.value);
              }
          }, 200);
      });
  } else {
      document.exitFullscreen().then(() => {
          // Reset após sair do fullscreen
          setTimeout(() => {
              if(dicomImageEl.value) {
                  cornerstone.resize(dicomImageEl.value, true);
                  cornerstone.reset(dicomImageEl.value);
              }
          }, 200);
      });
  }
}

// --- Progress Bar Methods ---
function updateVisualProgressBar(event) {
  const progressBarContainer = event.currentTarget;
  const rect = progressBarContainer.getBoundingClientRect();
  const clientX = event.touches ? event.touches[0].clientX : event.clientX;
  const x = clientX - rect.left;
  const percentage = Math.max(0, Math.min(1, x / rect.width));
  const newIndex = Math.round(percentage * (imageIds.value.length - 1));
  
  if (newIndex !== currentImageIndex.value) {
      currentImageIndex.value = newIndex;
  }
}

function handleMouseDown(e) { 
  isDraggingSlider.value = true; 
  updateVisualProgressBar(e);
}

function handleMouseMove(e) { 
  if (isDraggingSlider.value) { 
      updateVisualProgressBar(e); 
  } 
}

function handleMouseUp() {
  if (isDraggingSlider.value) {
      isDraggingSlider.value = false;
      // [NOVO] Usar a ferramenta nativa do Cornerstone em vez de carregar manualmente
      navigateToImageIndex(currentImageIndex.value);
  }
}

function handleMouseLeave() { 
  if (isDraggingSlider.value) {
      isDraggingSlider.value = false;
      // [NOVO] Usar a ferramenta nativa do Cornerstone em vez de carregar manualmente
      navigateToImageIndex(currentImageIndex.value);
  }
}

function handleTouchStart(e) { 
  isDraggingSlider.value = true; 
  updateVisualProgressBar(e);
}

function handleTouchMove(e) { 
  if (isDraggingSlider.value) { 
      updateVisualProgressBar(e);
  }
}

function handleTouchEnd() {
  if (isDraggingSlider.value) {
      isDraggingSlider.value = false;
      // [NOVO] Usar a ferramenta nativa do Cornerstone em vez de carregar manualmente
      navigateToImageIndex(currentImageIndex.value);
  }
}

// [NOVO] Variáveis para controlar navegação rápida
let navigationTimeout = null;
let currentNavigationPromise = null;
let lastNavigationIndex = -1;
// let isScrolling = false; // [NOVO] Variável global para controlar scroll (REMOVIDO)

// [NOVO] Função para navegar para um índice específico com carregamento não-bloqueante
function navigateToImageIndex(targetIndex) {
  // [NOVO] Não navegar se estiver carregando uma nova série
  if (isLoadingImage.value) {
    return;
  }
  
  if (targetIndex < 0 || targetIndex >= imageIds.value.length) return;
  
  // [NOVO] Cancelar navegação anterior se ainda estiver em andamento
  if (currentNavigationPromise) {
    currentNavigationPromise = null;
  }
  
  // [NOVO] Throttling para scroll rápido - aguardar 30ms antes de navegar
  if (navigationTimeout) {
    clearTimeout(navigationTimeout);
  }
  
  navigationTimeout = setTimeout(() => {
    // [NOVO] Verificar se o índice mudou durante o delay
    if (lastNavigationIndex === targetIndex) {
      return; // Mesmo índice, não navegar novamente
    }
    
    lastNavigationIndex = targetIndex;
    
    // [NOVO] Salvar viewport atual antes de navegar
    if (dicomImageEl.value && currentImageIndex.value !== targetIndex) {
      try {
        const currentViewport = cornerstone.getViewport(dicomImageEl.value);
        if (currentViewport) {
          savedViewport.value = {
            scale: currentViewport.scale,
            translation: { ...currentViewport.translation },
            voi: { ...currentViewport.voi },
            invert: currentViewport.invert,
            hflip: currentViewport.hflip,
            vflip: currentViewport.vflip,
            rotation: currentViewport.rotation
          };
        }
          } catch (error) {
      // Erro silencioso ao salvar viewport
    }
    }
    
    // [NOVO] Atualizar o índice atual imediatamente
    currentImageIndex.value = targetIndex;
    
    // [NOVO] Carregar imagem de forma completamente não-bloqueante
    const imageId = imageIds.value[targetIndex];
    
    // [NOVO] Usar Web Worker ou setTimeout para carregamento completamente assíncrono
    currentNavigationPromise = new Promise((resolve, reject) => {
      // [NOVO] Usar setTimeout com delay mínimo para não bloquear a thread principal
      setTimeout(() => {
        // [NOVO] Verificar se foi cancelada
        if (currentNavigationPromise === null) {
          return;
        }
        
        // [NOVO] Carregar imagem em chunks para não bloquear
        cornerstone.loadAndCacheImage(imageId)
          .then((image) => {
            // [NOVO] Verificar se foi cancelada ou se o índice mudou
            if (currentNavigationPromise === null || currentImageIndex.value !== targetIndex) {
              return;
            }
            
            // [NOVO] Usar requestAnimationFrame para display não-bloqueante
            requestAnimationFrame(() => {
              try {
                cornerstone.displayImage(dicomImageEl.value, image);
                updateWatermark(image);

                const stack = { imageIds: imageIds.value, currentImageIdIndex: targetIndex };
                cornerstoneTools.clearToolState(dicomImageEl.value, 'stack');
                cornerstoneTools.addToolState(dicomImageEl.value, 'stack', stack);

                // [NOVO] Ativar StackScroll após carregar a primeira imagem (se for a primeira vez)
                if (targetIndex === 0 && currentImageIndex.value === 0) {
                    setTimeout(() => {
                        cornerstoneTools.setToolActive('StackScroll', { mouseButtonMask: 1 });
                        activeTool.value = 'StackScroll';
                    }, 50);
                }

                // [NOVO] Restaurar viewport em outro frame
                if (savedViewport.value) {
                  requestAnimationFrame(() => {
                    try {
                      const newViewport = cornerstone.getViewport(dicomImageEl.value);
                      if (newViewport) {
                        newViewport.scale = savedViewport.value.scale;
                        newViewport.translation = { ...savedViewport.value.translation };
                        newViewport.voi = { ...savedViewport.value.voi };
                        newViewport.invert = savedViewport.value.invert;
                        newViewport.hflip = savedViewport.value.hflip;
                        newViewport.vflip = savedViewport.value.vflip;
                        newViewport.rotation = savedViewport.value.rotation;
                        
                        cornerstone.setViewport(dicomImageEl.value, newViewport);
                      }
                    } catch (error) {
                      // Erro silencioso ao restaurar viewport
                    }
                  });
                }
              } catch (error) {
                // Erro silencioso ao exibir imagem
              }
            });
            
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      }, 1); // Delay mínimo de 1ms para não bloquear
    });
    
  }, 30); // Throttling reduzido para 30ms
}

// [NOVO] Métodos para redimensionamento do painel
function startResizePanel(event) {
  isResizingPanel.value = true;
  event.preventDefault();
  document.body.classList.add('resizing');
  document.addEventListener('mousemove', handleResizePanel);
  document.addEventListener('mouseup', stopResizePanel);
}

function handleResizePanel(event) {
  if (!isResizingPanel.value) return;
  
  // Calcular a largura baseada na posição do mouse
  // O painel está na direita, então a largura é window.innerWidth - clientX
  const newWidth = ((window.innerWidth - event.clientX) / window.innerWidth) * 100;
  const clampedWidth = Math.max(minPanelWidth, Math.min(maxPanelWidth, newWidth));
  

  
  panelWidth.value = clampedWidth;
  
  // Redimensionar o canvas durante o arraste
  resizeCornerstoneCanvas();
}

function stopResizePanel() {
  isResizingPanel.value = false;
  document.body.classList.remove('resizing');
  document.removeEventListener('mousemove', handleResizePanel);
  document.removeEventListener('mouseup', stopResizePanel);
  
  // Redimensionar o canvas após parar de redimensionar o painel
  setTimeout(() => {
      resizeCornerstoneCanvas();
  }, 100);
}

// [NOVO] Método para controlar o botão (clique vs arraste)
let buttonClickStartX = 0;
let buttonClickStartY = 0;
let isButtonDragging = false;

function handleButtonMouseDown(event) {
  // Não permitir interação se o botão estiver desabilitado
  if (isLaudoButtonDisabled.value) {
      return;
  }
  
  buttonClickStartX = event.clientX;
  buttonClickStartY = event.clientY;
  isButtonDragging = false;
  
  // Adicionar listeners para detectar arraste
  document.addEventListener('mousemove', handleButtonMouseMove);
  document.addEventListener('mouseup', handleButtonMouseUp);
  document.addEventListener('mouseleave', handleButtonMouseLeave);
}

// [NOVO] Função para capturar o fim da transição do viewer
function onViewerTransitionEnd() {
  resizeCornerstoneCanvas();
}

// [NOVO] Função para forçar redimensionamento quando a margem muda
function forceResizeOnMarginChange() {
  // Forçar redimensionamento imediato
  if (dicomImageEl.value) {
      try {
          cornerstone.resize(dicomImageEl.value, true);
      } catch (error) {
          // Erro silencioso
      }
  }
  
  // E também com delays
  setTimeout(() => {
      resizeCornerstoneCanvas();
  }, 50);
  
  setTimeout(() => {
      resizeCornerstoneCanvas();
  }, 200);
}

// [NOVO] Função para atualizar dados do paciente quando carregados pelo LaudoModal
function atualizarDadosPaciente(dadosPaciente) {
    // Atualizar dados do paciente com informações completas do agendamento
    pacienteAtual.value = {
        ...pacienteAtual.value, // Manter dados existentes
        ...dadosPaciente, // Sobrescrever com dados atualizados
        // Garantir que o appointmentId seja atualizado
        appointmentId: dadosPaciente.appointmentId || pacienteAtual.value.appointmentId
    };
}



// [NOVO] Métodos para controlar o botão de impressão (clique vs arraste)
let printButtonClickStartX = 0;
let printButtonClickStartY = 0;
let isPrintButtonDragging = false;

function handlePrintButtonMouseDown(event) {
  printButtonClickStartX = event.clientX;
  printButtonClickStartY = event.clientY;
  isPrintButtonDragging = false;
  
  // Adicionar listeners para detectar arraste
  document.addEventListener('mousemove', handlePrintButtonMouseMove);
  document.addEventListener('mouseup', handlePrintButtonMouseUp);
  document.addEventListener('mouseleave', handlePrintButtonMouseLeave);
}

function handlePrintButtonMouseMove(event) {
  const deltaX = Math.abs(event.clientX - printButtonClickStartX);
  const deltaY = Math.abs(event.clientY - printButtonClickStartY);
  
  // Se moveu mais de 5px em qualquer direção, é um arraste
  if (deltaX > 5 || deltaY > 5) {
      isPrintButtonDragging = true;
      
      // Só abrir o painel se o botão estiver visível e o usuário tiver permissão
      if (shouldShowLaudoButton.value && canPrintSeries.value) {
          // Se o painel não estiver aberto, abrir primeiro
          if (!showPrintSeriesModal.value) {
              showPrintSeriesModal.value = true;
          }
          
          // Aguardar um tick para o painel renderizar antes de redimensionar
          setTimeout(() => {
              startResizePrintPanel(event);
          }, 50);
      }
      
      document.removeEventListener('mousemove', handlePrintButtonMouseMove);
      document.removeEventListener('mouseup', handlePrintButtonMouseUp);
      document.removeEventListener('mouseleave', handlePrintButtonMouseLeave);
  }
}

// [NOVO] Função para lidar com o mouse saindo da janela (botão de impressão)
function handlePrintButtonMouseLeave() {
  // Se o mouse sair da janela durante o arraste, parar o processo
  if (isPrintButtonDragging) {
      document.removeEventListener('mousemove', handlePrintButtonMouseMove);
      document.removeEventListener('mouseup', handlePrintButtonMouseUp);
      document.removeEventListener('mouseleave', handlePrintButtonMouseLeave);
      isPrintButtonDragging = false;
  }
}

// [NOVO] Função para lidar com iframes durante o arraste
function handleIframeMouseEnter() {
  // Se o mouse entrar em um iframe durante o arraste, parar o processo
  if (isButtonDragging || isPrintButtonDragging) {
      // Limpar todos os listeners
      document.removeEventListener('mousemove', handleButtonMouseMove);
      document.removeEventListener('mouseup', handleButtonMouseUp);
      document.removeEventListener('mouseleave', handleButtonMouseLeave);
      document.removeEventListener('mousemove', handlePrintButtonMouseMove);
      document.removeEventListener('mouseup', handlePrintButtonMouseUp);
      document.removeEventListener('mouseleave', handlePrintButtonMouseLeave);
      
      isButtonDragging = false;
      isPrintButtonDragging = false;
  }
}

function handlePrintButtonMouseUp() {
  // Se não foi arraste e o botão está visível e o usuário tem permissão, alternar o painel
  if (!isPrintButtonDragging && shouldShowLaudoButton.value && canPrintSeries.value) {
      showPrintSeriesModal.value = !showPrintSeriesModal.value;
  }
  
  document.removeEventListener('mousemove', handlePrintButtonMouseMove);
  document.removeEventListener('mouseup', handlePrintButtonMouseUp);
  document.removeEventListener('mouseleave', handlePrintButtonMouseLeave);
}

// [NOVO] Métodos para redimensionamento do painel de impressão
function startResizePrintPanel(event) {
  isResizingPrintPanel.value = true;
  event.preventDefault();
  document.body.classList.add('resizing');
  document.addEventListener('mousemove', handleResizePrintPanel);
  document.addEventListener('mouseup', stopResizePrintPanel);
}

function handleResizePrintPanel(event) {
  if (!isResizingPrintPanel.value) return;
  
  // Calcular a largura baseada na posição do mouse
  // O painel está na direita, então a largura é window.innerWidth - clientX
  const newWidth = ((window.innerWidth - event.clientX) / window.innerWidth) * 100;
  const clampedWidth = Math.max(minPanelWidth, Math.min(maxPanelWidth, newWidth));
  
  printPanelWidth.value = clampedWidth;
  
  // Redimensionar o canvas durante o arraste
  resizeCornerstoneCanvas();
}

function stopResizePrintPanel() {
  isResizingPrintPanel.value = false;
  document.body.classList.remove('resizing');
  document.removeEventListener('mousemove', handleResizePrintPanel);
  document.removeEventListener('mouseup', stopResizePrintPanel);
  
  // Redimensionar o canvas após parar de redimensionar o painel
  setTimeout(() => {
      resizeCornerstoneCanvas();
  }, 100);
}

// [NOVO] Função para redimensionar o canvas do Cornerstone
function resizeCornerstoneCanvas() {
  // Limpar timeout anterior
  if (resizeTimeout) {
      clearTimeout(resizeTimeout);
  }
  
  // Debounce de 50ms para evitar muitas chamadas
  resizeTimeout = setTimeout(() => {
      if (dicomImageEl.value) {
          try {
              // [NOVO] Salvar viewport atual antes do redimensionamento
              let currentViewport = null;
              try {
                currentViewport = cornerstone.getViewport(dicomImageEl.value);
              } catch (error) {
                // Erro silencioso ao obter viewport
              }
              
              // [NOVO] Forçar um reflow antes de redimensionar
              dicomImageEl.value.offsetHeight;
              
              cornerstone.resize(dicomImageEl.value, true);
              
              // [NOVO] Reotimizar canvas após redimensionamento
              setTimeout(() => {
                const canvas = dicomImageEl.value.querySelector('canvas');
                if (canvas && !canvas.dataset.optimized) {
                  canvas.getContext('2d', { willReadFrequently: true });
                  canvas.dataset.optimized = 'true';
                }
              }, 100);
              
              // [NOVO] Restaurar viewport após redimensionar (se não for reset)
              if (currentViewport && !savedViewport.value) {
                setTimeout(() => {
                  if (dicomImageEl.value) {
                    try {
                      cornerstone.setViewport(dicomImageEl.value, currentViewport);
                    } catch (error) {
                      // Erro silencioso ao restaurar viewport
                    }
                  }
                }, 100);
              }
              
              // [NOVO] Redimensionar novamente após um tempo para garantir
              setTimeout(() => {
                  if (dicomImageEl.value) {
                      try {
                          cornerstone.resize(dicomImageEl.value, true);
                      } catch (error) {
                          // Erro silencioso no segundo redimensionamento
                      }
                  }
              }, 300);
              
              // [NOVO] Redimensionar uma terceira vez para garantir
              setTimeout(() => {
                  if (dicomImageEl.value) {
                      try {
                          cornerstone.resize(dicomImageEl.value, true);
                      } catch (error) {
                          // Erro silencioso no terceiro redimensionamento
                      }
                  }
              }, 600);
              
          } catch (error) {
              // Erro silencioso ao redimensionar canvas
          }
      }
  }, 50);
}

function handleButtonMouseMove(event) {
  const deltaX = Math.abs(event.clientX - buttonClickStartX);
  const deltaY = Math.abs(event.clientY - buttonClickStartY);
  
  // Se moveu mais de 5px em qualquer direção, é um arraste
  if (deltaX > 5 || deltaY > 5) {
      isButtonDragging = true;
      
      // Só abrir o painel se o botão estiver visível e não estiver desabilitado
      if (shouldShowLaudoButton.value && !isLaudoButtonDisabled.value) {
          // Se o painel não estiver aberto, abrir primeiro
          if (!showLaudoPanel.value) {
              showLaudoPanel.value = true;
          }
          
          // Aguardar um tick para o painel renderizar antes de redimensionar
          setTimeout(() => {
              startResizePanel(event);
          }, 50);
      }
      
      document.removeEventListener('mousemove', handleButtonMouseMove);
      document.removeEventListener('mouseup', handleButtonMouseUp);
  }
}

// [NOVO] Função para lidar com o mouse saindo da janela
function handleButtonMouseLeave() {
  // Se o mouse sair da janela durante o arraste, parar o processo
  if (isButtonDragging) {
      document.removeEventListener('mousemove', handleButtonMouseMove);
      document.removeEventListener('mouseup', handleButtonMouseUp);
      document.removeEventListener('mouseleave', handleButtonMouseLeave);
      isButtonDragging = false;
  }
}

function handleButtonMouseUp() {
  // Se não foi arraste e o botão está visível e não está desabilitado, alternar o painel
  if (!isButtonDragging && shouldShowLaudoButton.value && !isLaudoButtonDisabled.value) {
      showLaudoPanel.value = !showLaudoPanel.value;
  }
  
  document.removeEventListener('mousemove', handleButtonMouseMove);
  document.removeEventListener('mouseup', handleButtonMouseUp);
  document.removeEventListener('mouseleave', handleButtonMouseLeave);
}

async function handleSolicitarImagemAtual(cellIdx) {
  if (printSeriesModalRef.value) {
    // Tentar capturar a imagem com retry
    const canvasImage = await captureCurrentCanvasImageWithRetry();
    if (canvasImage) {
      printSeriesModalRef.value.atribuirImagemNaCelula(currentImageIndex.value, cellIdx, canvasImage);
    } else {
      console.error('Falha ao capturar imagem do canvas após tentativas');
      // Fallback: usar a imagem original
      printSeriesModalRef.value.atribuirImagemNaCelula(currentImageIndex.value, cellIdx);
    }
  } else {
    console.error('Referência do modal de impressão não encontrada');
  }
}

// Função para capturar imagem com retry
function captureCurrentCanvasImageWithRetry(maxRetries = 3, delay = 100) {
return new Promise((resolve) => {
  let attempts = 0;
  
  const tryCapture = () => {
    attempts++;
    
    const result = captureCurrentCanvasImage();
    if (result) {
      resolve(result);
      return;
    }
    
    if (attempts < maxRetries) {
      setTimeout(tryCapture, delay);
    } else {
      console.error(`Falha após ${maxRetries} tentativas`);
      resolve(null);
    }
  };
  
  tryCapture();
});
}

// Função para capturar a imagem atual do canvas do Cornerstone
function captureCurrentCanvasImage() {
try {
  const canvas = dicomImageEl.value?.querySelector('canvas');
  if (!canvas) {
    console.error('Canvas não encontrado');
    return null;
  }
  
  // Verificar se o canvas tem conteúdo
  if (canvas.width === 0 || canvas.height === 0) {
    console.error('Canvas vazio ou não renderizado');
    return null;
  }
  
  // Criar um novo canvas para processar a imagem
  const tempCanvas = document.createElement('canvas');
  const tempCtx = tempCanvas.getContext('2d', { willReadFrequently: true });
  
  // Definir as dimensões do canvas temporário
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  
  // Desenhar a imagem do canvas original no temporário
  tempCtx.drawImage(canvas, 0, 0);
  
  // Verificar se a imagem foi desenhada corretamente
  const imageData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
  if (imageData.data.every(pixel => pixel === 0)) {
    console.error('Canvas parece estar vazio');
    return null;
  }
  
      // Converter para base64 com qualidade reduzida para menor tamanho
    const imageDataUrl = tempCanvas.toDataURL('image/jpeg', 0.6);
    
    console.log(`Imagem capturada: ${(imageDataUrl.length / 1024).toFixed(1)}KB`);
    
    return imageDataUrl;
  
} catch (error) {
  console.error('Erro ao capturar imagem do canvas:', error);
  return null;
}
}

// [NOVO] Função para abrir laudo em nova janela popup
function abrirLaudoEmPopup() {
if (!pacienteAtual.value) {
  alert('Nenhum paciente carregado para abrir o laudo.');
  return;
}

// Verificar se o paciente tem dados mínimos necessários
if (!pacienteAtual.value.nome || !pacienteAtual.value.numAcesso) {
  alert('Dados do paciente incompletos para abrir o laudo.');
  return;
}

try {
  // URL fixa para a popup (sem parâmetros na URL)
  // Os dados do paciente são enviados via postMessage após a popup abrir
  const baseUrl = window.location.origin;
  const popupUrl = `${baseUrl}/laudo-popup`;

  // Configurações da janela popup (tamanho reduzido)
  const popupFeatures = [
    'width=580',
    'height=550',
    'scrollbars=yes',
    'resizable=yes',
    'toolbar=no',
    'menubar=no',
    'location=no',
    'status=no',
    'directories=no',
    'copyhistory=no',
    'centerscreen=yes'
  ].join(',');

  // Abrir a nova janela
  popupWindow.value = window.open(popupUrl, 'LaudoModal', popupFeatures);

  if (!popupWindow.value) {
    alert('O bloqueador de popup impediu a abertura da nova janela. Por favor, permita popups para este site.');
    return;
  }

      // Marcar popup como aberto
    isPopupOpen.value = true;

    // Fechar o painel de laudo se estiver aberto
    if (showLaudoPanel.value) {
        showLaudoPanel.value = false;
    }

    // Focar na nova janela
    popupWindow.value.focus();

    // Aguardar um pouco para a popup carregar antes de configurar a comunicação
    setTimeout(() => {
      // Popup aberta, aguardando comunicação
    }, 500);

  // Listener para quando a popup for fechada
      const checkClosed = setInterval(() => {
      if (popupWindow.value && popupWindow.value.closed) {
        clearInterval(checkClosed);
        // Marcar popup como fechado
        isPopupOpen.value = false;
        popupWindow.value = null;
      }
    }, 1000);

      // Listener para comunicação entre janelas (opcional)
    const handlePopupMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      
      switch (event.data.type) {
        case 'TEST_COMMUNICATION':
          // Teste de comunicação recebido
          break;
        case 'REQUEST_PACIENTE_DATA':
          // Verificar se há dados do paciente disponíveis
          if (!pacienteAtual.value) {
            try {
              if (popupWindow.value && !popupWindow.value.closed) {
                popupWindow.value.postMessage({
                  type: 'PACIENTE_DATA_ERROR',
                  error: 'Nenhum paciente carregado'
                }, window.location.origin);
              }
            } catch (error) {
              console.error('ComponentViewer: Erro ao enviar erro de dados do paciente:', error);
            }
            return;
          }

          try {
            // Verificar se a popup ainda está aberta
            if (!popupWindow.value || popupWindow.value.closed) {
              return;
            }
            
            // Enviar dados do paciente para a popup (serializados para evitar DataCloneError)
            const pacienteDataSerializado = JSON.parse(JSON.stringify(pacienteAtual.value));
            
            popupWindow.value.postMessage({
              type: 'PACIENTE_DATA',
              data: pacienteDataSerializado
            }, window.location.origin);
            
          } catch (error) {
            console.error('Erro ao serializar dados do paciente:', error);
            try {
              if (popupWindow.value && !popupWindow.value.closed) {
                popupWindow.value.postMessage({
                  type: 'PACIENTE_DATA_ERROR',
                  error: 'Erro ao processar dados do paciente'
                }, window.location.origin);
              }
            } catch (postError) {
              console.error('ComponentViewer: Erro ao enviar mensagem de erro:', postError);
            }
          }
          break;
        case 'LAUDO_SAVED':
          // Laudo salvo na popup
          break;
        case 'LAUDO_FINALIZED':
          // Laudo finalizado na popup
          break;
        case 'LAUDO_REVIEWED':
          // Laudo revisado na popup
          break;
        case 'LAUDO_ADDENDA_ADDED':
          // Adendo adicionado na popup
          break;
        case 'LAUDO_SIGNED':
          // Laudo assinado na popup
          break;
        case 'LAUDO_POPUP_CLOSED':
          // Marcar popup como fechado
          isPopupOpen.value = false;
          popupWindow.value = null;
          break;
      }
    };
  
  window.addEventListener('message', handlePopupMessage);
  
  // Cleanup do listener quando a popup for fechada
  const cleanup = () => {
    window.removeEventListener('message', handlePopupMessage);
  };
  
  // Substituir o intervalo de verificação original com cleanup
  clearInterval(checkClosed);
      const newCheckClosed = setInterval(() => {
      if (popupWindow.value && popupWindow.value.closed) {
        clearInterval(newCheckClosed);
        cleanup();
        // Marcar popup como fechado
        isPopupOpen.value = false;
        popupWindow.value = null;
      }
    }, 1000);

} catch (error) {
  console.error('Erro ao abrir popup do laudo:', error);
  alert('Erro ao abrir a janela do laudo. Tente novamente.');
}
}

// [NOVO] Estado para controlar se o popup está aberto
const popupWindow = ref(null);
const isPopupOpen = ref(false);

// [NOVO] Estado para controlar o cine
const isCineActive = ref(false);
const cineDirection = ref('forward'); // 'forward' ou 'reverse'
const cineSpeed = ref(1); // FPS
const cineInterval = ref(null);
const cineTimeout = ref(null);

// [NOVO] Estado para controlar o menu suspenso do cine
const showCineMenu = ref(false);

// [NOVO] Computed para mostrar ou não o botão de popup
const shouldShowPopupButton = computed(() => {
    const result = !isEmbeddedInIframe.value && !isPopupOpen.value;
    // Não mostrar o botão se estiver em iframe ou se o popup estiver aberto
    return result;
});

// [NOVO] Computed para desabilitar o botão de laudo quando popup estiver aberto
const isLaudoButtonDisabled = computed(() => {
  return isPopupOpen.value;
});

// [NOVO] Propriedade computada para calcular a posição do menu do cine
const cineMenuPosition = computed(() => {
  if (!showCineMenu.value) return {};
  
  const cineButton = document.querySelector('.cine-dropdown-container .toolbar-btn');
  if (!cineButton) return {};
  
  const rect = cineButton.getBoundingClientRect();
  
  return {
    position: 'fixed',
    top: `${rect.bottom + 5}px`,
    left: `${rect.left}px`,
    zIndex: '10000'
  };
});

// [NOVO] Função para alternar o menu do cine
function toggleCineMenu() {
  showCineMenu.value = !showCineMenu.value;
}

// [NOVO] Função para definir a direção do cine
function setCineDirection(direction) {
  cineDirection.value = direction;
}

// [NOVO] Função para definir a velocidade do cine
function setCineSpeed(speed) {
  cineSpeed.value = speed;
  if (isCineActive.value) {
    updateCineSpeed();
  }
}

// [NOVO] Função para ativar o cine
function activateCineTool() {
  if (imageIds.value.length <= 1) {
    alert('É necessário ter mais de uma imagem para usar o cine.');
    return;
  }
  
  // [NOVO] Preservar a ferramenta ativa atual
  const currentActiveTool = activeTool.value;
  
  isCineActive.value = true;
  startCine();
  
  // [NOVO] Restaurar a ferramenta ativa após um breve delay
  setTimeout(() => {
    if (currentActiveTool && currentActiveTool !== 'StackScroll') {
      activateTool(currentActiveTool);
    }
  }, 100);
}



// [NOVO] Função para parar o cine
function stopCine() {
  isCineActive.value = false;
  if (cineInterval.value) {
    clearInterval(cineInterval.value);
    cineInterval.value = null;
  }
  if (cineTimeout.value) {
    clearTimeout(cineTimeout.value);
    cineTimeout.value = null;
  }
}

// [NOVO] Função para atualizar a velocidade do cine
function updateCineSpeed() {
  if (isCineActive.value) {
    // Reiniciar o cine com a nova velocidade
    stopCine();
    startCine();
  }
}

// [NOVO] Função para iniciar o cine
function startCine() {
  if (!isCineActive.value || imageIds.value.length <= 1) {
    return;
  }
  
  const intervalMs = 1000 / cineSpeed.value; // Converter FPS para milissegundos
  
  cineInterval.value = setInterval(() => {
    if (!isCineActive.value) {
      return;
    }
    
    // [NOVO] Pausar o cine se o usuário estiver interagindo com ferramentas
    if (isDraggingSlider.value || isLoadingImage.value || isLoadingSeries.value) {
      return;
    }
    
    let nextIndex;
    if (cineDirection.value === 'forward') {
      nextIndex = currentImageIndex.value + 1;
      if (nextIndex >= imageIds.value.length) {
        nextIndex = 0; // Voltar ao início
      }
    } else {
      nextIndex = currentImageIndex.value - 1;
      if (nextIndex < 0) {
        nextIndex = imageIds.value.length - 1; // Ir para o final
      }
    }
    
    // [NOVO] Usar uma abordagem mais suave que não interfere com as ferramentas
    if (nextIndex !== currentImageIndex.value) {
      // Salvar viewport atual
      let currentViewport = null;
      try {
        currentViewport = cornerstone.getViewport(dicomImageEl.value);
      } catch (error) {
        // Erro silencioso
      }
      
      // Atualizar índice sem usar navigateToImageIndex
      currentImageIndex.value = nextIndex;
      
      // Carregar imagem diretamente
      const imageId = imageIds.value[nextIndex];
      cornerstone.loadAndCacheImage(imageId)
        .then((image) => {
          if (!isCineActive.value) return; // Verificar se ainda está ativo
          
          requestAnimationFrame(() => {
            try {
              cornerstone.displayImage(dicomImageEl.value, image);
              updateWatermark(image);
              
              // Atualizar stack state
              const stack = {
                currentImageIdIndex: nextIndex,
                imageIds: imageIds.value
              };
              cornerstoneTools.clearToolState(dicomImageEl.value, 'stack');
              cornerstoneTools.addToolState(dicomImageEl.value, 'stack', stack);
              
              // [NOVO] Preservar medições existentes
              setTimeout(() => {
                handleMeasurementEvent();
              }, 50);
              
              // [NOVO] Restaurar viewport preservado
              if (currentViewport) {
                requestAnimationFrame(() => {
                  try {
                    const newViewport = cornerstone.getViewport(dicomImageEl.value);
                    if (newViewport) {
                      newViewport.scale = currentViewport.scale;
                      newViewport.translation = { ...currentViewport.translation };
                      newViewport.voi = { ...currentViewport.voi };
                      newViewport.invert = currentViewport.invert;
                      newViewport.hflip = currentViewport.hflip;
                      newViewport.vflip = currentViewport.vflip;
                      newViewport.rotation = currentViewport.rotation;
                      
                      cornerstone.setViewport(dicomImageEl.value, newViewport);
                    }
                  } catch (error) {
                    // Erro silencioso ao restaurar viewport
                  }
                });
              }
            } catch (error) {
              // Erro silencioso ao exibir imagem
            }
          });
        })
        .catch((error) => {
          console.warn('Erro ao carregar imagem no cine:', error);
        });
    }
  }, intervalMs);
}



</script>

<style>
/* O CSS permanece o mesmo */
@import 'tailwindcss/base';
@import 'tailwindcss/components';
@import 'tailwindcss/utilities';

:root {
--primary-color: #2563eb;
--secondary-color: #1e40af;
--dark-bg: #1e293b;
--light-text: #f8fafc;
--toolbar-height: 60px;
--series-width: 300px;
}

body {
margin: 0;
font-family: 'Inter', system-ui, -apple-system, sans-serif;
background-color: var(--dark-bg);
color: var(--light-text);
overflow: hidden;
}

.toolbar {
height: var(--toolbar-height);
background: var(--dark-bg);
border-bottom: 1px solid rgba(255,255,255,0.1);
padding: 0 1rem;
display: flex;
align-items: center;
gap: 1rem;
position: fixed;
top: 0; left: 0; right: 0;
z-index: 1000;
overflow-x: auto;
white-space: nowrap;
scrollbar-width: thin;
scrollbar-color: rgba(37, 99, 235, 0.8) rgba(255, 255, 255, 0.1);
}

.toolbar::-webkit-scrollbar {
height: 6px;
}

.toolbar::-webkit-scrollbar-track {
background: rgba(255, 255, 255, 0.05);
border-radius: 8px;
margin: 0 10px;
}

.toolbar::-webkit-scrollbar-thumb {
background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
border-radius: 8px;
transition: all 0.3s ease;
}

.toolbar::-webkit-scrollbar-thumb:hover {
background: linear-gradient(90deg, #3b82f6, #2563eb);
box-shadow: 0 0 10px rgba(37, 99, 235, 0.4);
}

.toolbar::-webkit-scrollbar-corner {
background: transparent;
}

/* Fade gradient nos extremos para indicar scroll */
.toolbar::before,
.toolbar::after {
content: '';
position: absolute;
top: 0;
width: 20px;
height: 100%;
pointer-events: none;
z-index: 1;
transition: opacity 0.3s ease;
}

.toolbar::before {
left: 0;
background: linear-gradient(90deg, var(--dark-bg) 0%, transparent 100%);
}

.toolbar::after {
right: 0;
background: linear-gradient(270deg, var(--dark-bg) 0%, transparent 100%);
}

/* Smooth scroll behavior */
.toolbar {
scroll-behavior: smooth;
}

/* Hide scrollbar on mobile but keep functionality */
@media (max-width: 768px) {
.toolbar::-webkit-scrollbar {
  height: 0px;
}

.toolbar {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
}

.toolbar-btn {
background-color: rgba(255,255,255,0.1);
border: none;
color: var(--light-text);
padding: 0.5rem 1rem;
border-radius: 0.5rem;
display: flex;
align-items: center;
gap: 0.5rem;
transition: all 0.2s;
font-size: 0.875rem;
}

.toolbar-btn:hover {
background-color: var(--primary-color);
color: white;
}

.toolbar-btn.active {
background-color: var(--primary-color);
color: white;
}

.toolbar-group {
display: flex;
gap: 0.5rem;
align-items: center;
border-right: 1px solid rgba(255,255,255,0.1);
padding-right: 1rem;
flex-shrink: 0;
}

.toolbar-group:last-child {
border-right: none;
}

.main-container {
display: flex;
height: calc(100vh - var(--toolbar-height));
margin-top: var(--toolbar-height);
position: relative;
transition: all 0.3s ease;
}

.series-panel {
width: var(--series-width);
background: rgba(0, 0, 0, 0.2);
padding: 1rem;
overflow-y: auto;
position: relative;
scrollbar-width: thin;
scrollbar-color: var(--primary-color) rgba(255, 255, 255, 0.1);
transition: all 0.3s ease-in-out;
transform: translateX(0);
}

.series-panel.collapsed {
  width: 0;
  padding: 0;
  transform: translateX(calc(-1 * var(--series-width)));
  overflow: hidden;
}

.series-item {
background: rgba(255,255,255,0.05);
border-radius: 0.75rem;
padding: 0.75rem;
margin-bottom: 1rem;
cursor: pointer;
transition: all 0.2s;
}

.series-item:hover {
background: rgba(255,255,255,0.1);
transform: translateY(-2px);
}

.series-item img {
width: 100%;
border-radius: 0.5rem;
margin-bottom: 0.5rem;
aspect-ratio: 1 / 1;
object-fit: cover;
background-color: #000;
}

.series-item p {
margin: 0;
font-size: 0.875rem;
color: rgba(255,255,255,0.8);
}

.viewer-container {
flex: 1;
display: flex;
flex-direction: column;
background: #000;
position: relative;
overflow: hidden;
transition: margin-right 0.3s ease;
}

.viewer-with-panel {
margin-right: 0;
}

.viewer, .mpr-container {
width: 100%;
height: 100%;
}
.viewer.hidden, .mpr-container:not(.active) {
display: none;
}

.mpr-container.active {
display: grid;
grid-template-columns: 1fr 1fr;
grid-template-rows: 1fr 1fr;
gap: 2px;
background: #333;
}

.watermark {
position: absolute;
top: 5px;
left: 5px;
font-size: 0.8vw;
color: yellow;
z-index: 10;
pointer-events: none;
white-space: pre-wrap;
line-height: 1.2;
background: rgba(0,0,0,0.5);
padding: 5px;
border-radius: 3px;
}

#imageSliderContainer {
position: absolute; bottom: 10px; left: 10px; right: 10px;
background: rgba(0, 0, 0, 0.8); padding: 0.5rem; z-index: 20;
text-align: center; border-radius: 5px;
}
#progressBarContainer {
position: relative; width: 100%; height: 8px; background-color: #000000;
display: flex; align-items: center; margin: 10px 0; touch-action: pan-y;
cursor: pointer;
}
#progressBar {
height: 100%; background: linear-gradient(90deg, #2563eb, #34d399);
border-radius: 5px; 
pointer-events: none;
position: relative;
z-index: 2;
}
#progressHandle {
width: 16px; height: 16px; border-radius: 50%; background-color: #34d399;
position: absolute; top: 50%; transform: translate(-50%, -50%);
cursor: pointer; touch-action: none;
pointer-events: none;
z-index: 3;
}
.preloading-progress-bar {
position: absolute;
left: 0;
top: 0;
height: 100%;
background-color: rgba(100, 116, 139, 0.5);
border-radius: 5px;
z-index: 1;
transition: width 0.2s ease-in-out;
}

.measurement-panel, .presets-panel {
position: absolute; background: rgba(0,0,0,0.8); color: white;
padding: 10px; border-radius: 5px; z-index: 15; display: none;
}
.measurement-panel { top: 10px; right: 10px; max-width: 250px; }
.presets-panel { top: 70px; left: 10px; }

.measurement-panel.active, .presets-panel.active { display: block; }
.measurement-item { margin-bottom: 5px; font-size: 0.8rem; }

.preset-btn {
display: block; width: 100%; margin-bottom: 5px; padding: 5px 10px;
background: rgba(255,255,255,0.1); border: none; color: white;
border-radius: 3px; cursor: pointer; transition: background 0.2s;
text-align: left;
}
.preset-btn:hover { background: var(--primary-color); }

.loading-overlay {
position: absolute;
top: 0; left: 0; right: 0; bottom: 0;
background-color: rgba(0, 0, 0, 0.7);
display: flex;
justify-content: center;
align-items: center;
z-index: 100;
color: white;
font-size: 1.2rem;
}

.loading-text {
color: rgba(255, 255, 255, 0.8);
padding: 1rem;
text-align: center;
display: flex;
flex-direction: column;
align-items: center;
gap: 1rem;
}

/* [NOVO] Estilos para carregamento de série */
.series-loading {
display: flex;
flex-direction: column;
align-items: center;
gap: 1.5rem;
padding: 2rem;
background: rgba(0, 0, 0, 0.8);
border-radius: 12px;
border: 1px solid rgba(37, 99, 235, 0.3);
box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
backdrop-filter: blur(10px);
min-width: 300px;
}

.image-loading {
display: flex;
flex-direction: column;
align-items: center;
gap: 1rem;
}

.loading-spinner {
width: 40px;
height: 40px;
border: 3px solid rgba(37, 99, 235, 0.3);
border-top: 3px solid #2563eb;
border-radius: 50%;
animation: spin 1s linear infinite;
}

.loading-message {
font-size: 1.2rem;
font-weight: 600;
color: #ffffff;
text-align: center;
}

.loading-subtitle {
font-size: 0.9rem;
color: rgba(255, 255, 255, 0.7);
text-align: center;
max-width: 250px;
line-height: 1.4;
}

@keyframes spin {
0% { transform: rotate(0deg); }
100% { transform: rotate(360deg); }
}

/* [NOVO] Estilos para o botão e painel lateral do laudo */
.laudo-panel-toggle-btn {
position: fixed;
top: calc(50% + var(--toolbar-height) / 2);
right: 0;
z-index: 4000;
background: #2563eb;
color: #fff;
border: none;
border-radius: 8px 0 0 8px;
padding: 0.7rem 0.5rem;
box-shadow: 0 2px 8px rgba(0,0,0,0.15);
cursor: pointer;
transition: right 0.3s ease;
min-height: 80px;
display: flex;
align-items: center;
justify-content: center;
user-select: none;
-webkit-user-select: none;
-moz-user-select: none;
-ms-user-select: none;
}

/* [NOVO] Estilos para o botão desabilitado */
.laudo-panel-toggle-btn.disabled {
background: #6b7280;
cursor: not-allowed;
opacity: 0.6;
}

.laudo-panel-toggle-btn.disabled:hover {
background: #6b7280;
transform: none;
}

/* [NOVO] Estilos para o botão de impressão de séries */
.print-series-toggle-btn {
position: fixed;
top: calc(50% + var(--toolbar-height) / 2 + 100px);
right: 0;
z-index: 4000;
background: #059669;
color: #fff;
border: none;
border-radius: 8px 0 0 8px;
padding: 0.7rem 0.5rem;
box-shadow: 0 2px 8px rgba(0,0,0,0.15);
cursor: pointer;
transition: all 0.2s ease;
min-height: 80px;
display: flex;
align-items: center;
justify-content: center;
user-select: none;
-webkit-user-select: none;
-moz-user-select: none;
-ms-user-select: none;
}

.print-series-toggle-btn:hover {
background: #047857;
transform: translateX(-2px);
}

/* [NOVO] Cursor quando o painel está aberto */
.laudo-panel-toggle-btn[aria-expanded="true"] {
cursor: col-resize;
}

/* [NOVO] Cursor quando o painel de impressão está aberto */
.print-series-toggle-btn[aria-expanded="true"] {
cursor: col-resize;
}

/* [NOVO] Estilo para texto vertical */
.writing-mode-vertical {
writing-mode: vertical-rl;
text-orientation: mixed;
transform: rotate(180deg);
white-space: nowrap;
font-family: 'Inter', 'Segoe UI', system-ui, sans-serif;
font-weight: 700;
letter-spacing: 0.1em;
text-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

/* [NOVO] Estilo para rotacionar o ícone */
.rotate-icon {
transform: rotate(90deg);
}

.laudo-panel-drawer {
position: fixed;
top: var(--toolbar-height);
right: 0;
height: calc(100vh - var(--toolbar-height));
background: #fff;
box-shadow: -2px 0 16px rgba(0,0,0,0.18);
z-index: 3000;
display: flex;
flex-direction: column;
overflow-y: auto;
min-width: 350px;
max-width: 80vw;
border-radius: 8px 0 0 8px;
}

.print-panel-drawer {
position: fixed;
top: var(--toolbar-height);
right: 0;
height: calc(100vh - var(--toolbar-height));
background: #1e293b;
box-shadow: -2px 0 16px rgba(0,0,0,0.18);
z-index: 3000;
display: flex;
flex-direction: column;
overflow-y: auto;
min-width: 350px;
max-width: 80vw;
border-radius: 8px 0 0 8px;
}

/* [NOVO] Cursor durante redimensionamento */
body.resizing {
cursor: col-resize !important;
user-select: none;
}

@media (max-width: 900px) {
.laudo-panel-drawer {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  top: var(--toolbar-height);
  height: calc(100vh - var(--toolbar-height));
}

.print-panel-drawer {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  top: var(--toolbar-height);
  height: calc(100vh - var(--toolbar-height));
}

.viewer-container {
  margin-right: 0 !important;
}

.print-series-toggle-btn {
  top: calc(50% + var(--toolbar-height) / 2 + 90px);
  min-height: 70px;
  padding: 0.5rem 0.4rem;
}
}
.slide-laudo-panel-enter-active, .slide-laudo-panel-leave-active {
transition: all 0.3s cubic-bezier(.4,0,.2,1);
}
.slide-laudo-panel-enter-from, .slide-laudo-panel-leave-to {
transform: translateX(100%);
opacity: 0;
}
.slide-laudo-panel-enter-to, .slide-laudo-panel-leave-from {
transform: translateX(0);
opacity: 1;
}

.slide-print-panel-enter-active, .slide-print-panel-leave-active {
transition: all 0.3s cubic-bezier(.4,0,.2,1);
}
.slide-print-panel-enter-from, .slide-print-panel-leave-to {
transform: translateX(100%);
opacity: 0;
}
.slide-print-panel-enter-to, .slide-print-panel-leave-from {
transform: translateX(0);
opacity: 1;
}

/* [NOVO] Estilos para menu suspenso do cine */
.cine-dropdown-container {
  position: relative;
  z-index: 10000;
}

/* [NOVO] Estilos para menu fixo do cine */
.cine-dropdown-menu-fixed {
  position: fixed;
  min-width: 280px;
  background: var(--dark-bg);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  z-index: 10000;
  backdrop-filter: blur(10px);
  animation: dropdownSlideIn 0.2s ease-out;
}

.dropdown-arrow {
  margin-left: 0.25rem;
  transition: transform 0.2s ease;
}

.cine-dropdown-container .toolbar-btn.active .dropdown-arrow {
  transform: rotate(180deg);
}

.cine-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  min-width: 280px;
  background: var(--dark-bg);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  z-index: 10000;
  margin-top: 0.5rem;
  backdrop-filter: blur(10px);
  animation: dropdownSlideIn 0.2s ease-out;
}

.cine-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.cine-menu-header h4 {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--light-text);
}

.close-menu-btn {
  background: none;
  border: none;
  color: var(--light-text);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 0.25rem;
  transition: background-color 0.2s;
}

.close-menu-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.cine-controls-section {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.cine-controls-section:last-child {
  border-bottom: none;
}

.cine-section-label {
  display: block;
  font-size: 0.8rem;
  color: var(--light-text);
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.cine-control-row {
  display: flex;
  gap: 0.5rem;
}

.cine-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.25rem;
  color: var(--light-text);
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.8rem;
}

.cine-btn:hover:not(:disabled) {
  background: var(--primary-color);
  border-color: var(--primary-color);
}

.cine-btn.active {
  background: var(--primary-color);
  border-color: var(--primary-color);
}

.cine-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cine-direction-controls {
  display: flex;
  gap: 0.5rem;
}

.direction-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.25rem;
  color: var(--light-text);
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.8rem;
}

.direction-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.direction-btn.active {
  background: var(--primary-color);
  border-color: var(--primary-color);
}

.speed-control-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.cine-speed-slider {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  outline: none;
  cursor: pointer;
  -webkit-appearance: none;
}

.cine-speed-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  background: var(--primary-color);
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.cine-speed-slider::-moz-range-thumb {
  width: 18px;
  height: 18px;
  background: var(--primary-color);
  border-radius: 50%;
  cursor: pointer;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.speed-presets {
  display: flex;
  gap: 0.25rem;
}

.speed-preset-btn {
  flex: 1;
  padding: 0.25rem 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.25rem;
  color: var(--light-text);
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.7rem;
  text-align: center;
}

.speed-preset-btn:hover {
  background: var(--primary-color);
  border-color: var(--primary-color);
}

.cine-status-section {
  padding: 0.75rem 1rem;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 0.25rem;
  margin: 0.5rem 1rem;
}

.status-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
}

.status-item:last-child {
  margin-bottom: 0;
}

.status-label {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.7);
}

.status-value {
  font-size: 0.75rem;
  color: var(--light-text);
  font-weight: 600;
}

.status-value.active {
  color: #10b981;
}

@keyframes dropdownSlideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* [NOVO] Estilos para controles do cine (legado - removido) */
.cine-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: rgba(37, 99, 235, 0.1);
  border-radius: 0.5rem;
  border: 1px solid rgba(37, 99, 235, 0.3);
}

.cine-label {
  font-size: 0.75rem;
  color: var(--light-text);
  white-space: nowrap;
}

.cine-speed-value {
  font-size: 0.75rem;
  color: var(--light-text);
  font-weight: 600;
  min-width: 50px;
  text-align: center;
}

@media (max-width: 768px) {
  .watermark { font-size: 2.5vw; }
  .series-panel {
    position: fixed; top: var(--toolbar-height); left: 0; width: 100%;
    height: calc(100vh - var(--toolbar-height)); background-color: #1e293b;
    z-index: 1010; transform: translateX(-100%); transition: transform 0.3s ease;
  }
  .series-panel.show { transform: translateX(0); }
  .series-panel.collapsed { display: block; } 

  .overlay {
    position: fixed; top: 0; left: 0; width: 100%; height: 100%;
    background: rgba(0, 0, 0, 0.7); z-index: 1009;
    opacity: 0; visibility: hidden; transition: opacity 0.3s ease, visibility 0.3s ease;
  }
  .overlay.active { opacity: 1; visibility: visible; }
  
  .main-container { display: block; }
  .viewer { height: calc(100vh - var(--toolbar-height)); }

  .toolbar { 
    padding: 0.3rem; 
    gap: 0.2rem; 
  }
  .toolbar-btn { 
    padding: 0.4rem 0.6rem; 
    font-size: 0.75rem; 
    flex-shrink: 0;
  }
  .toolbar-group { 
    gap: 0.3rem; 
    border-right: none; 
    padding-right: 0.5rem; 
  }
  
  .print-series-toggle-btn {
    top: calc(50% + var(--toolbar-height) / 2 + 80px);
    min-height: 60px;
    padding: 0.4rem 0.3rem;
  }
  
  .print-series-toggle-btn .text-xs {
    font-size: 0.6rem;
  }
  
  /* [NOVO] Estilos responsivos para carregamento */
  .series-loading {
    min-width: 280px;
    padding: 1.5rem;
    gap: 1rem;
  }
  
  .loading-message {
    font-size: 1rem;
  }
  
  .loading-subtitle {
    font-size: 0.8rem;
    max-width: 220px;
  }
  
  .loading-spinner {
    width: 32px;
    height: 32px;
  }
  
  /* [NOVO] Estilos responsivos para menu do cine */
  .cine-dropdown-menu {
    min-width: 250px;
    right: 0;
    left: auto;
  }
  
  .cine-control-row {
    flex-direction: column;
  }
  
  .cine-direction-controls {
    flex-direction: column;
  }
  
  .speed-presets {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .cine-menu-header h4 {
    font-size: 0.8rem;
  }
  
  .cine-btn, .direction-btn {
    font-size: 0.75rem;
    padding: 0.4rem;
  }
  
  .speed-preset-btn {
    font-size: 0.65rem;
    padding: 0.2rem 0.4rem;
  }
  
  /* [NOVO] Estilos responsivos para controles do cine (legado) */
  .cine-controls {
    flex-direction: column;
    gap: 0.3rem;
    padding: 0.3rem;
  }
  
  .cine-speed-slider {
    width: 60px;
  }
  
  .cine-speed-value {
    font-size: 0.7rem;
  }
}

/* [NOVO] Estilos para o banner de compartilhamento */
.share-info-banner {
  position: fixed;
  top: var(--toolbar-height);
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #1e40af, #3b82f6);
  color: white;
  padding: 0.75rem 1rem;
  z-index: 1001;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.share-info-content {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.share-info-text {
  display: flex;

  gap: 0.25rem;
}

.share-label {
  font-weight: 600;
  font-size: 0.9rem;
}

.share-details {
  
  font-size: 0.9rem;
  opacity: 0.9;
}

.share-expired {
  background: rgba(239, 68, 68, 0.9);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 0.85rem;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

/* [NOVO] Estilos para o modal de expiração */
.expired-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
}

.expired-modal {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
}

.expired-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.expired-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.expired-modal h2 {
  color: #dc2626;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
}

.expired-modal p {
  color: #374151;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
}

.expired-modal-btn {
  background: #dc2626;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-top: 1rem;
}

.expired-modal-btn:hover {
  background: #b91c1c;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 768px) {
  .expired-modal {
    padding: 1.5rem;
    margin: 1rem;
  }
  
  .expired-icon {
    font-size: 3rem;
  }
  
  .expired-modal h2 {
    font-size: 1.5rem;
  }
  
  .expired-modal p {
    font-size: 0.9rem;
  }
}

/* Ajustar o main-container quando há banner de compartilhamento */
.main-container.has-share-banner {
  margin-top: calc(var(--toolbar-height) + 60px); /* toolbar + banner */
}

@media (max-width: 768px) {
  .share-info-content {
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
  }
  
  .share-info-text {
    align-items: center;
  }
  
  .main-container.has-share-banner {
    margin-top: calc(var(--toolbar-height) + 80px); /* toolbar + banner maior no mobile */
  }
}
</style>